// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

::ng-deep .cig-parent-wrapper {
  /*--------owl carousel ------------*/
  /* clearfix */
  /* display none until init */
  /* mouse grab icon */
  /* fix */
  /* Styling Next and Prev buttons */
  /* Clickable class fix problem with hover on touch devices */
  /* Use it for non-touch hover action */
  /* Styling Pagination*/
  /* If PaginationNumbers is true */
  /* preloading images */
  /* Style-for-interpretive-short*/
  /* dynamic-style-update*/
  /* DAshboard-Map-Style-update*/
  /* feedback-large-icon*/
}
::ng-deep .cig-parent-wrapper #nav {
  position: relative;
  z-index: 5000;
  text-align: center;
  background: rgba(0, 0, 0, 0.6);
  max-width: 920px;
  margin: 0 auto;
  width: 100%;
}
::ng-deep .cig-parent-wrapper #nav #prevtBtn,
::ng-deep .cig-parent-wrapper #nav #nextBtn {
  cursor: pointer;
}
::ng-deep .cig-parent-wrapper .feedback-slider {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  flex-direction: column-reverse;
  display: flex;
  margin-top: -100px;
  min-height: 685px;
}
::ng-deep .cig-parent-wrapper #Dots {
  position: absolute;
  z-index: 5000;
  bottom: 12px;
  left: 50%;
  transform: translate(-50%, 0%);
  background: rgba(0, 0, 0, 0.1);
  z-index: 99999;
  max-width: 855px;
}
::ng-deep .cig-parent-wrapper .Dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: relative;
  float: left;
  background-color: #fff;
  opacity: 1;
  margin: 5px;
  margin-bottom: 0px;
  cursor: pointer;
  border: 2px solid rgba(255, 255, 255, 0.7);
  background-color: #666;
  border: 2px solid rgba(0, 0, 0, 0.7);
}
::ng-deep .cig-parent-wrapper .Dot:first-child {
  background-color: rgba(0, 0, 0, 0.5) !important;
  border-color: rgba(0, 0, 0, 0.5) !important;
}
::ng-deep .cig-parent-wrapper #prevtBtn,
::ng-deep .cig-parent-wrapper #nextBtn {
  /*color: #666767;*/
  color: #fff;
  font-size: 33px;
  margin: 0px;
  position: relative;
}
::ng-deep .cig-parent-wrapper #prevtBtn {
  float: left;
}
::ng-deep .cig-parent-wrapper #nextBtn {
  float: right;
}
::ng-deep .cig-parent-wrapper .feedback {
  width: 100%;
  height: auto;
  font-size: 40px;
  /*position: absolute;
  /*color: white;*/
  /*top:15%;
  bottom:70px;
  left:0px;*/
}
::ng-deep .cig-parent-wrapper #owl-demo {
  max-width: 980px;
  width: 100%;
  margin: 0 auto;
  -ms-box-shadow: 0px 0px 39px -5px #676a6c;
  box-shadow: 0px 0px 39px -5px #676a6c;
}
::ng-deep .cig-parent-wrapper #owl-demo .item {
  display: block;
  width: 100%;
  min-height: 515px;
  background-repeat: no-repeat;
  background-size: cover;
}
::ng-deep .cig-parent-wrapper #owl-demo .item .feedback-wrapper {
  display: block;
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
}
::ng-deep .cig-parent-wrapper .owl-carousel .owl-wrapper:after {
  content: ".";
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
}
::ng-deep .cig-parent-wrapper .owl-carousel {
  display: none;
  position: relative;
  width: 100%;
  -ms-touch-action: pan-y;
}
::ng-deep .cig-parent-wrapper .owl-carousel .owl-wrapper {
  display: none;
  position: relative;
  -webkit-transform: translate3d(0px, 0px, 0px);
}
::ng-deep .cig-parent-wrapper .owl-carousel .owl-wrapper-outer {
  overflow: hidden;
  position: relative;
  width: 100%;
}
::ng-deep .cig-parent-wrapper .owl-carousel .owl-wrapper-outer.autoHeight {
  transition: height 500ms ease-in-out;
}
::ng-deep .cig-parent-wrapper .owl-carousel .owl-item {
  float: left;
}
::ng-deep .cig-parent-wrapper .owl-controls .owl-page,
::ng-deep .cig-parent-wrapper .owl-controls .owl-buttons div {
  cursor: pointer;
}
::ng-deep .cig-parent-wrapper .owl-controls {
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
::ng-deep .cig-parent-wrapper .grabbing {
  cursor: url(https://cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/grabbing.png) 8 8, move;
}
::ng-deep .cig-parent-wrapper .owl-carousel .owl-wrapper,
::ng-deep .cig-parent-wrapper .owl-carousel .owl-item {
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls {
  margin-top: -20px;
  text-align: center;
  position: relative;
  z-index: 999999;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-pagination {
    display: none !important;
  }
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-buttons div {
  position: relative;
  display: inline-block;
  zoom: 1;
  display: inline;
  /*IE7 life-saver */
  margin: 5px 2px;
  overflow: hidden;
  width: 40px;
  height: 45px;
  line-height: 45px;
  font-size: 0px;
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-buttons div:before {
  font-size: 40px;
  font-family: "FontAwesome";
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  filter: Alpha(Opacity=70);
  /*IE7 fix*/
  opacity: 0.7;
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-buttons div.owl-prev:before {
  content: "\\f137";
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-buttons div.owl-next:before {
  content: "\\f138";
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls.clickable .owl-buttons div:hover:before {
  filter: Alpha(Opacity=100);
  /*IE7 fix*/
  opacity: 1;
  text-decoration: none;
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-page {
  display: inline-block;
  zoom: 1;
  display: inline;
  /*IE7 life-saver */
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-page span {
  display: block;
  width: 8px;
  height: 8px;
  margin: 4px;
  border-radius: 20px;
  background: #6c6c6c !important;
  filter: Alpha(Opacity=50);
  /*IE7 fix*/
  opacity: 0.5;
}
@media (max-width: 860px) {
  ::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-page span {
    margin: 4px 3px;
  }
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-page.active span,
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls.clickable .owl-page:hover span {
  background-color: #3b3937 !important;
  filter: Alpha(Opacity=100);
  /*IE7 fix*/
  opacity: 1;
}
::ng-deep .cig-parent-wrapper .owl-buttons {
  position: absolute;
  right: 15px;
  top: -40px;
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-page span.owl-numbers {
  height: auto;
  width: auto;
  color: #fff;
  padding: 2px 10px;
  font-size: 12px;
  border-radius: 30px;
}
::ng-deep .cig-parent-wrapper .owl-item.loading {
  min-height: 150px;
  background: url(https://cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/AjaxLoader.gif) no-repeat center center;
}
@media (max-width: 767px) {
  ::ng-deep .cig-parent-wrapper #owl-demo .item {
    min-height: 475px;
  }
  ::ng-deep .cig-parent-wrapper .owl-theme .owl-controls {
    margin-top: 0px;
  }
  ::ng-deep .cig-parent-wrapper .owl-buttons {
    position: relative;
    top: inherit;
    right: inherit;
  }
  ::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-page span {
    margin: 2px;
  }
}
::ng-deep .cig-parent-wrapper .feedback-page .wrapper-content {
  max-height: 80vh;
  overflow: auto;
}
::ng-deep .cig-parent-wrapper #feed-banner {
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: center center !important;
}
::ng-deep .cig-parent-wrapper #feed-banner .title {
  color: #fff;
}
::ng-deep .cig-parent-wrapper #great-mind {
  background-repeat: no-repeat !important;
  background-size: cover !important;
}
::ng-deep .cig-parent-wrapper #great-mind .title-sm {
  color: #fff;
}
::ng-deep .cig-parent-wrapper #think {
  background-repeat: no-repeat !important;
  background-color: #fff !important;
  background-size: contain !important;
  background-position: left 62% !important;
}
::ng-deep .cig-parent-wrapper #f-bulb {
  background-repeat: no-repeat !important;
  background-color: #bfbfbf !important;
  background-size: initial !important;
  background-position: center center !important;
}
::ng-deep .cig-parent-wrapper #f-bulb .title {
  position: absolute;
  top: 50%;
  text-align: center;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  line-height: 60px;
}
::ng-deep .cig-parent-wrapper #f-now {
  background-repeat: no-repeat !important;
  background-size: cover !important;
}
::ng-deep .cig-parent-wrapper #f-now .title-sm {
  color: #fff;
  float: left;
  background: rgba(243, 243, 243, 0.3) !important;
  min-width: 200px;
  padding: 10px;
}
::ng-deep .cig-parent-wrapper #f-end {
  background-repeat: no-repeat !important;
  background-size: cover !important;
}
::ng-deep .cig-parent-wrapper #f-end .feedback-content img {
  margin: 20px 0;
}
::ng-deep .cig-parent-wrapper #congo .feedback-content img {
  margin: 0 0 20px;
}
::ng-deep .cig-parent-wrapper #f4-stage .title-sm {
  margin-bottom: 30px;
}
::ng-deep .cig-parent-wrapper .f-sight {
  margin-top: 45px;
}
::ng-deep .cig-parent-wrapper .f-score .col-xs-5 {
  margin-top: 28px;
}
::ng-deep .cig-parent-wrapper .s-icon .fa {
  margin: 5px;
  cursor: pointer;
}
::ng-deep .cig-parent-wrapper #f-fit .feedback-content img {
  max-width: 450px;
}
::ng-deep .cig-parent-wrapper .feedback-player {
  width: calc(100% - 65px);
  float: right;
  padding: 5px;
}
::ng-deep .cig-parent-wrapper .feedback-content {
  padding: 50px 50px 0;
}
::ng-deep .cig-parent-wrapper .feedback-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(243, 243, 243, 0.8) !important;
  padding: 5px 5px 32px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .cig-parent-wrapper .feedback-footer {
    padding: 5px;
  }
}
@media (max-width: 767px) {
  ::ng-deep .cig-parent-wrapper .feedback-footer .feed-logo {
    display: none;
  }
}
::ng-deep .cig-parent-wrapper .feedback-footer audio {
  width: calc(100% - 335px) !important;
  margin-bottom: -3px;
  backface-visibility: hidden;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .cig-parent-wrapper .feedback-footer audio {
    width: calc(100% - 205px) !important;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .cig-parent-wrapper .feedback-footer audio {
    width: calc(100% - 175px) !important;
  }
}
@media only screen and (max-width: 575px) {
  ::ng-deep .cig-parent-wrapper .feedback-footer audio {
    width: calc(100% - 60px) !important;
  }
}
::ng-deep .cig-parent-wrapper .feedback-footer .author-logo {
  float: left;
}
::ng-deep .cig-parent-wrapper .feedback .feedback-wrapper {
  top: 50% !important;
}
::ng-deep .cig-parent-wrapper .feedback audio::-moz-media-controls-panel {
  background: transparent;
}
::ng-deep .cig-parent-wrapper .feedback audio::-webkit-media-controls-current-time-display,
::ng-deep .cig-parent-wrapper .feedback audio::-webkit-media-controls-time-remaining-display {
  color: #676a6c;
}
::ng-deep .cig-parent-wrapper div#Dots {
  /*background: rgba(0,0,0,.4);*/
  text-align: left;
  width: 100%;
  display: block;
  bottom: 74px;
  padding: 0px;
  padding-left: 8%;
  background: transparent;
  /*max-width:920px;*/
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  transform: none;
}
::ng-deep .cig-parent-wrapper div#Dots .Dot {
  display: inline-block;
  float: none !important;
  background-color: #fff;
  border-color: #fff;
}
::ng-deep .cig-parent-wrapper #nav {
  left: 0px;
  right: 0px;
  position: absolute !important;
  bottom: 90px !important;
  background: transparent !important;
  max-width: 980px !important;
}
::ng-deep .cig-parent-wrapper #prevtBtn {
  float: right !important;
  margin-right: 60px !important;
  color: #6c6c6c !important;
  bottom: 0px;
  right: 0;
  position: absolute !important;
  font-size: 40px !important;
}
::ng-deep .cig-parent-wrapper #nextBtn {
  color: #6c6c6c !important;
  position: absolute !important;
  font-size: 40px !important;
  right: 20px;
  bottom: 0;
}
::ng-deep .cig-parent-wrapper .cig_collab_img img {
  max-height: 300px;
}
@media only screen and (max-width: 599px) {
  ::ng-deep .cig-parent-wrapper .feedback p {
    font-size: 15px;
  }
}
::ng-deep .cig-parent-wrapper .feedback .right-label-text .eq-developer {
  padding: 7px;
  color: #fff;
  font-size: 16px;
}
::ng-deep .cig-parent-wrapper .feedback .fix-label {
  background: #6d6e71;
  color: #fff;
  font-size: 28px;
  padding: 7px;
  font-family: "Museo-700";
  display: inline-block;
  vertical-align: top;
}
::ng-deep .cig-parent-wrapper .feedback .about-u {
  background: #f1f1f2;
  overflow: hidden;
  margin-bottom: 10px;
}
::ng-deep .cig-parent-wrapper .feedback .about-u .right-label {
  display: block;
  margin-bottom: 10px;
  text-align: right;
}
::ng-deep .cig-parent-wrapper .feedback-test_result {
  max-width: 400px;
  margin: 0px auto;
  text-align: center;
}
@media only screen and (max-height: 414px) and (orientation: landscape) {
  ::ng-deep .cig-parent-wrapper .feedback-test_result {
    transform: scale(0.8);
    margin-top: -15px;
  }
}
::ng-deep .cig-parent-wrapper .feedback-test_result .big-profile {
  display: inline-block;
}
::ng-deep .cig-parent-wrapper .feedback-test_result p {
  display: inline-block;
  background: #6d6e71;
  color: #fff;
  padding: 7px;
  margin: 0;
  vertical-align: super;
  font-family: "Museo-700";
}
::ng-deep .cig-parent-wrapper .test-last .title-sm {
  font-size: 26px;
}
::ng-deep .cig-parent-wrapper .test-last p {
  font-size: 12px;
  margin-bottom: 0px;
  color: #666;
}
::ng-deep .cig-parent-wrapper .product-box {
  padding: 0;
  border: none;
  box-shadow: 10px 10px 10px -3px #676a6c;
}
::ng-deep .cig-parent-wrapper .product-box:hover, ::ng-deep .cig-parent-wrapper .product-box:active {
  border: none;
  box-shadow: 3px 3px 7px 0px #a8a8a8;
}
::ng-deep .cig-parent-wrapper .dashboard-wrapper .car-big-heading img {
  max-width: 325px !important;
}
::ng-deep .cig-parent-wrapper .practioner-dash-wrap {
  margin-top: 0px;
}
::ng-deep .cig-parent-wrapper .icon-btn {
  position: absolute;
  bottom: 5px;
  font-size: 22px;
  color: #676a6c;
  margin: auto;
  left: 0;
  right: 0;
  display: inline-block;
}
::ng-deep .cig-parent-wrapper .icon-btn:hover {
  color: #48ac51;
}
::ng-deep .cig-parent-wrapper .fs-logo-feedback {
  max-width: 350px;
  margin: 30px auto 0;
}
::ng-deep .cig-parent-wrapper #f-implement1 .profile-description {
  font-size: 15px;
}
@media (max-width: 960px) {
  ::ng-deep .cig-parent-wrapper #f-implement1 .profile-description {
    max-height: 245px;
    overflow: hidden;
    overflow-y: auto;
  }
}
@media (max-width: 767px) {
  ::ng-deep .cig-parent-wrapper #f-implement1 .profile-description {
    font-size: 12px;
    max-height: 310px;
  }
  body.mini-navbar ::ng-deep .cig-parent-wrapper #f-implement1 .profile-description {
    max-height: 302px;
  }
}
@media (max-width: 414px) {
  ::ng-deep .cig-parent-wrapper #f-implement1 .profile-description {
    max-height: 250px;
  }
}
@media only screen and (max-height: 414px) and (orientation: landscape) {
  ::ng-deep .cig-parent-wrapper #f-implement1 .profile-description {
    max-height: 115px !important;
    font-size: 13px !important;
  }
}
::ng-deep .cig-parent-wrapper #f-implement1 .fix-label {
  font-size: 23px;
}
@media (max-width: 767px) {
  ::ng-deep .cig-parent-wrapper #f-implement1 .fix-label {
    font-size: 16px;
    float: left;
  }
}
::ng-deep .cig-parent-wrapper #f-implement1 .about-u {
  padding: 10px;
}
@media (max-width: 767px) {
  ::ng-deep .cig-parent-wrapper #f-implement1 .about-u {
    margin-bottom: 5px;
  }
  ::ng-deep .cig-parent-wrapper #f-implement1 .about-u .right-label-text {
    font-size: 16px;
    margin-bottom: 0px;
    display: inline-block;
    vertical-align: top;
    padding: 7px;
    float: right;
  }
}
::ng-deep .cig-parent-wrapper #f-implement1 .right-label-text {
  font-size: 18px;
  color: #fff;
}
::ng-deep .cig-parent-wrapper #f-implement1 .right-label-text span {
  padding: 8px;
}
@media (max-width: 992px) {
  ::ng-deep .cig-parent-wrapper #f-implement1 .right-label-text span {
    padding: 3px;
    font-size: 14px;
  }
}
::ng-deep .cig-parent-wrapper .big-profile .profile_types {
  background: url("https://assets.foursightonline.com/app/images/foursight-profile-types-lg.png") !important;
  width: 160px;
  height: 80px;
}
::ng-deep .cig-parent-wrapper .big-profile .developer {
  background-position: -680px -84px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .accelerator {
  background-position: -170px 0 !important;
}
::ng-deep .cig-parent-wrapper .big-profile .analyst {
  background-position: 0 -174px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .clarifier {
  background-position: -345px -174px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .driver {
  background-position: -334px 0 !important;
}
::ng-deep .cig-parent-wrapper .big-profile .early-bird {
  background-position: -338px -84px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .finisher {
  background-position: -676px 0 !important;
}
::ng-deep .cig-parent-wrapper .big-profile .hare {
  background-position: -512px -174px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .idea-broker {
  background-position: -506px 0 !important;
}
::ng-deep .cig-parent-wrapper .big-profile .ideator {
  background-position: 0 -84px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .implementer {
  background-position: -170px -84px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .integrator {
  background-position: -680px -196px !important;
  margin-top: 0px;
  height: 40px;
}
::ng-deep .cig-parent-wrapper .big-profile .optimist {
  background-position: -172px -174px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .realist {
  background-position: -508px -84px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .theorist {
  background-position: 0 0 !important;
}
::ng-deep .cig-parent-wrapper video::-internal-media-controls-download-button,
::ng-deep .cig-parent-wrapper audio::-internal-media-controls-download-button {
  display: none;
}
::ng-deep .cig-parent-wrapper video::-webkit-media-controls-enclosure,
::ng-deep .cig-parent-wrapper audio::-webkit-media-controls-enclosure {
  overflow: hidden;
}
::ng-deep .cig-parent-wrapper video::-webkit-media-controls-panel,
::ng-deep .cig-parent-wrapper audio::-webkit-media-controls-panel {
  width: calc(100% + 30px);
}
::ng-deep .cig-parent-wrapper .interactive-guide {
  overflow: hidden;
}
::ng-deep .cig-parent-wrapper .interactive-guide .feedback {
  box-shadow: 0px 0px 39px -5px #676a6c;
  margin: 0px !important;
}
::ng-deep .cig-parent-wrapper ::ng-deep.flipbook {
  width: 100% !important;
  margin-top: 60px;
}
::ng-deep .cig-parent-wrapper ::ng-deep.flipbook .page-wrapper {
  margin: 0 auto !important;
}
::ng-deep .cig-parent-wrapper ::ng-deep.flipbook-viewport {
  overflow: hidden;
  width: 100%;
  height: 100%;
}
::ng-deep .cig-parent-wrapper ::ng-deep.flipbook-viewport .container {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: auto;
}
::ng-deep .cig-parent-wrapper ::ng-deep.flipbook-viewport .flipbook {
  width: 922px;
  height: 600px;
  left: -461px;
  top: -300px;
}
::ng-deep .cig-parent-wrapper ::ng-deep.flipbook-viewport .page {
  width: 461px;
  height: 600px;
  background-color: white;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::ng-deep .cig-parent-wrapper ::ng-deep.flipbook-viewport .shadow {
  -webkit-transition: -webkit-box-shadow 0.5s;
  -moz-transition: -moz-box-shadow 0.5s;
  -o-transition: -webkit-box-shadow 0.5s;
  -ms-transition: -ms-box-shadow 0.5s;
  -o-box-shadow: 0 0 20px #ccc;
  -ms-box-shadow: 0 0 20px #ccc;
  box-shadow: 0 0 20px #ccc;
}
::ng-deep .cig-parent-wrapper ::ng-deep.flipbook .page {
  -ms-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  -o-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}
::ng-deep .cig-parent-wrapper ::ng-deep.flipbook .page img {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  margin: 0;
  max-width: 100%;
}
::ng-deep .cig-parent-wrapper ::ng-deep.flipbook .feedback-footer audio {
  vertical-align: bottom;
  margin-top: 12px;
  margin-bottom: 0px;
}
::ng-deep .cig-parent-wrapper ::ng-deep.flipbook .f-score .col-xs-7 img {
  width: 100%;
}
::ng-deep .cig-parent-wrapper ::ng-deep.flipbook #f-implement img {
  max-width: 100%;
}
::ng-deep .cig-parent-wrapper ::ng-deep.flipbook .feedback-footer audio {
  width: calc(100% - 165px);
  min-width: 0px;
}
::ng-deep .cig-parent-wrapper ::ng-deep.flipbook #f-zone .feedback-content p {
  margin-top: 25%;
}
::ng-deep .cig-parent-wrapper ::ng-deep.flipbook #congo .title-sm {
  margin-top: 15%;
}
::ng-deep .cig-parent-wrapper ::ng-deep.flipbook #f-implement .title-sm {
  margin-bottom: 12%;
}
::ng-deep .cig-parent-wrapper ::ng-deep.flipbook .feedback .custom-col {
  width: 23%;
  margin: 1%;
}
::ng-deep .cig-parent-wrapper .flip-control {
  text-align: center;
}
::ng-deep .cig-parent-wrapper .flip-control a {
  display: inline-block;
  margin: 0px 5px;
}
@media only screen and (min-width: 1000px) and (max-width: 1200px) {
  ::ng-deep .cig-parent-wrapper .flipbook .col-xs-7,
  ::ng-deep .cig-parent-wrapper .flipbook .col-xs-5 {
    width: 100%;
  }
  ::ng-deep .cig-parent-wrapper .flipbook .title-sm {
    font-size: 26px !important;
  }
  ::ng-deep .cig-parent-wrapper .flipbook .feedback .title {
    font-size: 40px;
    line-height: 42px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .cig-parent-wrapper .flipbook .title-sm {
    font-size: 26px !important;
  }
  ::ng-deep .cig-parent-wrapper .flipbook .feedback .title {
    font-size: 40px;
    line-height: 42px;
  }
}
@media only screen and (max-width: 420px) {
  ::ng-deep .cig-parent-wrapper .flipbook .col-xs-7,
  ::ng-deep .cig-parent-wrapper .flipbook .col-xs-5 {
    width: 100%;
  }
  ::ng-deep .cig-parent-wrapper .flipbook .feedback .custom-col {
    width: 48%;
    margin: 1%;
  }
  ::ng-deep .cig-parent-wrapper .flipbook #think {
    background-size: inherit !important;
    background-position-y: 50% !important;
  }
  ::ng-deep .cig-parent-wrapper .flipbook #f-profile .title-sm {
    margin-bottom: 28%;
  }
}
::ng-deep .cig-parent-wrapper .circled-preference {
  border: 2px solid;
  border-radius: 65% 65%;
  padding: 20px 0px;
}

/* full-screen-style */
#full-screen {
  margin-left: 15px;
  margin-right: 15px;
}

a#exit-screen {
  display: none;
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 18px;
  color: #6c6c6c;
}

@media only screen and (max-width: 767px) and (orientation: portrait) {
  ::ng-deep body.full-screen {
    overflow: hidden;
    position: fixed;
  }
}
::ng-deep body.full-screen .feedback-page {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  background: #fff;
  left: 0;
  margin-top: 0px;
  padding: 0px;
}
@media only screen and (max-height: 414px) and (orientation: landscape) {
  ::ng-deep body.full-screen .feedback-page {
    position: absolute;
    overflow: hidden;
  }
}
::ng-deep body.full-screen .feedback-slider {
  margin: 0px;
}
::ng-deep body.full-screen a#exit-screen {
  display: block;
  z-index: 99;
}
::ng-deep body.full-screen .feedback {
  max-width: 100%;
  top: 0;
  bottom: 0;
}
::ng-deep body.full-screen .custom-row {
  overflow: hidden;
  width: 100%;
}
::ng-deep body.full-screen .owl-carousel .feedback-content .f-sight img,
::ng-deep body.full-screen .owl-carousel .feedback-content .f-score img {
  max-width: 150px;
  width: 100%;
}
@media only screen and (max-height: 414px) and (orientation: landscape) {
  ::ng-deep body.full-screen .owl-carousel .feedback-content .f-sight img,
  ::ng-deep body.full-screen .owl-carousel .feedback-content .f-score img {
    max-width: 115px;
  }
}

::ng-deep body.full-screen #owl-demo {
  width: 90%;
  margin-top: 35px;
}

@media only screen and (min-width: 768px) {
  ::ng-deep body.full-screen #owl-demo {
    margin-top: 60px;
  }
}
@media only screen and (max-height: 736px) and (orientation: portrait) {
  ::ng-deep body.full-screen #owl-demo {
    /*width: 90%;*/
    margin-top: 40px;
  }
}
@media only screen and (max-height: 414px) and (orientation: landscape) {
  ::ng-deep body.full-screen #owl-demo {
    margin-top: 40px;
    /*width: 100%;
      margin-top: 0px;
      -webkit-transform: scale(0.61);
      -moz-transform: scale(0.61);
      -ms-transform: scale(0.61);
      -o-transform: scale(0.61);
      transform: scale(0.61);
      position: relative;
      top: -70px;
      margin-left: -75px;
      width:90%;*/
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep body.full-screen .feedback ul li {
    font-size: 20px;
  }
  ::ng-deep body.full-screen .feedback .custom-col p {
    font-size: 16px;
  }
  ::ng-deep body.full-screen a#exit-screen {
    font-size: 16px;
  }
  ::ng-deep body.full-screen .feedback p {
    font-size: 16px;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback ul li {
    font-size: 16px;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback p {
    font-size: 16px;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback .custom-col {
    float: none;
  }
  ::ng-deep body.full-screen .owl-carousel #f-bulb {
    background-size: contain !important;
  }
}
::ng-deep .work-well-slide h3 {
  font-size: 22px;
}
::ng-deep .work-well-slide .title-sm {
  margin-bottom: 50px !important;
}
@media (max-width: 767px) {
  ::ng-deep .work-well-slide .title-sm {
    margin-bottom: 25px !important;
  }
}
::ng-deep .work-well-slide .disabled {
  height: 50px;
  vertical-align: middle;
  margin-top: 35px;
  font-size: 28px;
}
@media (max-width: 767px) {
  ::ng-deep .work-well-slide .disabled {
    margin: 0px;
  }
}

@media (min-width: 680px) {
  .new-dashboard .col-sm-3 {
    max-width: 180px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .feedback-page .col-xs-7,
  ::ng-deep .feedback-page .col-xs-5 {
    width: 100%;
  }
  ::ng-deep .feedback-page .feedback-content {
    padding: 20px 20px 0;
  }
  ::ng-deep .feedback-page #prevtBtn,
  ::ng-deep .feedback-page #nextBtn {
    font-size: 25px !important;
    bottom: 8px;
  }
  ::ng-deep .feedback-page #prevtBtn {
    margin-right: 30px !important;
  }
  ::ng-deep .feedback-page #nextBtn {
    right: 4px;
  }
  ::ng-deep .feedback-page div#Dots {
    padding-left: 16%;
  }
  ::ng-deep .feedback-page div#Dots .Dot {
    width: 5px;
    height: 5px;
    margin: 3px;
  }
  ::ng-deep .feedback-page a#exit-screen {
    top: 5px;
    right: 5px;
  }
}
@media only screen and (max-height: 414px) and (orientation: landscape) {
  ::ng-deep .feedback-page .col-xs-7 {
    width: 50% !important;
  }
  ::ng-deep .feedback-page .col-xs-5 {
    width: 50% !important;
  }
  ::ng-deep .work-well-slide .center-block {
    text-align: center;
  }
  ::ng-deep .work-well-slide .col-sm-2,
  .work-well-slide .col-sm-5 {
    display: inline-block;
    vertical-align: middle;
    width: 25%;
  }
  ::ng-deep body.full-screen {
    width: 100%;
    overflow: hidden;
  }
  ::ng-deep body.full-screen #owl-demo .item {
    min-height: 260px !important;
  }
  ::ng-deep body.full-screen #owl-demo #think.item {
    background-size: 60% auto !important;
    background-position: center center !important;
  }
  ::ng-deep body.full-screen #page-wrapper {
    min-height: 414px;
  }
  ::ng-deep body.full-screen .feedback p {
    font-size: 12px !important;
  }
  ::ng-deep body.full-screen .owl-carousel .title {
    font-size: 25px !important;
    line-height: 1.1 !important;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback .title-sm {
    font-size: 15px !important;
    margin-bottom: 5px;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback .f-sight {
    margin-top: 15px;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback ul li {
    font-size: 14px !important;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback p {
    font-size: 14px !important;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback .custom-col {
    width: 15%;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback .feedback-footer {
    max-height: 40px;
    padding: 0px 5px;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback .feedback-footer .author-logo {
    max-width: 40px;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback .feedback-footer .feedback-player {
    padding: 0px 5px;
    max-height: 40px;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback .feedback-footer .feedback-player audio {
    height: 40px;
    margin-bottom: 0px;
  }
  ::ng-deep body.full-screen .owl-carousel #f-profile #chartarea {
    transform: scale(0.58);
    margin-top: -40px;
    width: 100%;
  }
  ::ng-deep body.full-screen .owl-carousel #clar-result #chartarea,
  ::ng-deep body.full-screen .owl-carousel #w-ideat-result #chartarea,
  ::ng-deep body.full-screen .owl-carousel #w-develop-result #chartarea,
  ::ng-deep body.full-screen .owl-carousel #w-impl-result #chartarea {
    transform: scale(0.9);
  }
  ::ng-deep body.full-screen .owl-carousel #f-implement img {
    max-width: 200px;
  }
}
::ng-deep .feedback-page img {
  max-width: 100%;
}
::ng-deep .feedback-page .feedback .custom-col {
  width: 23%;
  margin: 1%;
}
@media (max-width: 767px) {
  ::ng-deep .feedback-page .feedback .custom-col {
    width: 20%;
    max-width: 122px !important;
    display: inline-block;
    float: none;
  }
}
@media (max-width: 599px) {
  ::ng-deep .feedback-page .feedback .custom-col {
    width: 33%;
    max-width: 105px !important;
  }
  ::ng-deep body.mini-navbar ::ng-deep .feedback-page .feedback .custom-col {
    width: 39%;
  }
}
@media (max-width: 767px) {
  ::ng-deep .feedback-page .feedback .custom-row {
    margin: 0 auto;
    display: inline-block;
    text-align: center;
    width: 100%;
  }
  ::ng-deep .feedback-page .feedback .custom-col:nth-child(3) {
    clear: both;
  }
}
::ng-deep .feedback-page .c-profile img {
  max-width: 300px;
}

::ng-deep .feedback {
  max-width: 980px;
  margin: auto;
  right: 0;
  text-align: left !important;
  font-family: "Museo-300";
  background: #fff;
}
::ng-deep .feedback .title {
  font-size: 60px;
  margin: 0px;
  font-weight: 600;
  font-family: "Museo-700";
}
::ng-deep .feedback .title-sm {
  font-size: 40px;
  margin: 0px 0 10px;
  font-weight: 600;
  font-family: "Museo-300";
}
@media (max-width: 991px) {
  ::ng-deep .feedback .title-sm {
    font-size: 30px;
  }
}
@media (max-width: 800px) {
  ::ng-deep .feedback .title-sm {
    font-size: 27px;
  }
}
::ng-deep .feedback .custom-row {
  display: flex;
  flex-wrap: wrap;
  margin-inline: -15px;
}
::ng-deep .feedback .custom-row .custom-col {
  width: 25%;
  padding-inline: 15px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .feedback .custom-row .custom-col {
    width: 50%;
  }
}
::ng-deep .feedback p {
  font-size: 18px;
}
::ng-deep .feedback ul {
  padding: 0 0 0 22px;
  margin: 0px;
}
::ng-deep .feedback ul li {
  font-size: 18px;
  line-height: 26px;
}
@media (max-width: 767px) {
  ::ng-deep .feedback ul li {
    font-size: 15px;
  }
  body.mini-navbar ::ng-deep .feedback ul li {
    font-size: 14px;
  }
}

@media only screen and (max-width: 767px) {
  ::ng-deep .feedback-page .title-sm {
    font-size: 20px !important;
    margin-bottom: 25px;
  }
  ::ng-deep .feedback-page .feedback .title {
    font-size: 40px;
    line-height: 42px !important;
  }
  body.full-screen .owl-carousel .feedback .title-sm {
    font-size: 20px !important;
  }
  body.full-screen .owl-carousel .title {
    font-size: 40px;
    line-height: 42px !important;
  }
}
@media only screen and (max-height: 736px) and (orientation: portrait) {
  body.full-screen #owl-demo .item {
    min-height: 430px;
  }
  body.full-screen .owl-carousel .feedback .title-sm {
    margin-bottom: 10px !important;
    font-size: 18px !important;
  }
  body.full-screen .owl-carousel .feedback .custom-col {
    max-width: 98px !important;
  }
  body.full-screen .owl-carousel .feedback .title {
    font-size: 35px !important;
    line-height: 1.1 !important;
  }
  body.full-screen .owl-carousel .feedback ul li {
    font-size: 14px !important;
  }
  body.full-screen .owl-carousel .feedback p {
    font-size: 14px !important;
    margin-bottom: 0px;
  }
  body.full-screen .owl-carousel .feedback .fs-logo-feedback img {
    max-width: 250px;
  }
  body.full-screen .owl-carousel .feedback .center-block {
    transform: scale(0.8);
    margin-top: -15px;
  }
  body.full-screen .owl-carousel #f-implement1 .profile-description {
    max-height: 255px;
  }
}
@media print {
  @page {
    size: letter landscape;
  }
  body {
    width: 100%;
    height: 100%;
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    max-height: 100%;
    max-width: 100%;
  }
  ::ng-deep body {
    width: 100% !important;
  }
  ::ng-deephtml {
    width: 100% !important;
  }
  ::ng-deepbody.fs-skin #wrapper {
    overflow: visible !important;
  }
  ::ng-deep .cig-parent-wrapper #owl-demo {
    max-width: 100% !important;
  }
  ::ng-deep .cig-parent-wrapper .owl-carousel .owl-wrapper-outer {
    overflow: visible !important;
  }
  ::ng-deep .cig-parent-wrapper .owl-item {
    float: none !important;
    width: 100% !important;
    min-height: 100% !important;
    clear: both;
    page-break-before: always !important;
    display: block !important;
    transform: translateY(20%) !important;
  }
  ::ng-deep .cig-parent-wrapper .owl-carousel .owl-wrapper {
    page-break-inside: always !important;
    float: none !important;
  }
  ::ng-deep .cig-parent-wrapper .owl-carousel .owl-wrapper,
  ::ng-deep .cig-parent-wrapper .owl-carousel .owl-item {
    width: 100% !important;
    white-space: normal !important;
    visibility: visible !important;
    opacity: 1 !important;
    float: none !important;
  }
  ::ng-deep .cig-parent-wrapper #feed-banner {
    background-image: url("https://assets.foursightonline.com/app/images/feed-banner.png") !important;
  }
  ::ng-deep .cig-parent-wrapper #great-mind {
    background-image: url("https://assets.foursightonline.com/app/images/2nd-page.png") !important;
  }
  ::ng-deep .cig-parent-wrapper #think {
    background-image: url("https://assets.foursightonline.com/app/images/think-pref.png") !important;
  }
  ::ng-deep .cig-parent-wrapper #f-bulb {
    background-image: url("https://assets.foursightonline.com/app/images/feed-bulb.png") !important;
  }
  ::ng-deep .cig-parent-wrapper #f-now {
    background-image: url("https://assets.foursightonline.com/app/images/f-now.png") !important;
  }
  ::ng-deep .cig-parent-wrapper #f-end {
    background-image: url("https://assets.foursightonline.com/app/images/f-end.png") !important;
  }
  ::ng-deep .cig-parent-wrapper .feedback-footer {
    display: none !important;
  }
  ::ng-deep .cig-parent-wrapper .owl-controls {
    display: none !important;
  }
  ::ng-deep body.fs-skin #hubspot-messages-iframe-container.widget-align-right {
    display: none !important;
  }
}
::ng-deep.translate-btn {
  position: absolute;
  bottom: 18px;
  right: 11%;
}

::ng-deep.translate-text {
  font-size: 16px !important;
  max-width: 980px;
  margin: 20px auto 0 auto;
}
::ng-deep.translate-text .well {
  max-height: 180px;
  overflow-y: auto;
}

::ng-deep.feedback-player {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

::ng-deep.cig-parent-wrapper .owl-buttons {
  position: absolute;
  right: 15px;
  top: auto;
  bottom: 35px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.cig-parent-wrapper .owl-buttons {
    bottom: -13px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.cig-parent-wrapper .owl-buttons {
    bottom: 3px;
  }
}
@media only screen and (max-width: 575px) {
  ::ng-deep.cig-parent-wrapper .owl-buttons {
    position: static;
  }
}

::ng-deep.translate-btn {
  position: absolute;
  bottom: 55px;
  right: 110px;
  background: transparent !important;
  border: transparent !important;
  color: #6c6c6c !important;
}
::ng-deep.translate-btn:active {
  box-shadow: none !important;
}
::ng-deep.translate-btn i::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.translate-btn {
    bottom: 29px;
  }
}
@media only screen and (max-width: 575px) {
  ::ng-deep.translate-btn {
    right: 10px;
  }
}

::ng-deep.translate-btn.translate-btn2 {
  right: 158px;
}

@media only screen and (max-width: 991px) {
  ::ng-deep.feedback-footer audio + img + img {
    display: none;
  }
}

::ng-deep.item.feedback {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: transparent;
}
::ng-deep.item.feedback--notitle {
  background-size: 100% 100%;
}
::ng-deep.item.feedback--fullscr {
  height: 90% !important;
}
::ng-deep.item.feedback--mh {
  min-height: auto;
}
::ng-deep.item.feedback--thanku .test-last h2 {
  font-size: 26px;
  margin-bottom: 26px;
}
::ng-deep.item.feedback--thanku .test-last button {
  margin-bottom: 10px;
}
::ng-deep.item.feedback--thanku .test-last p {
  font-size: 12px;
  margin-bottom: 0px;
  color: #666;
}
::ng-deep.item.feedback--thanku .test-last .fs-icon a {
  margin: 5px;
  cursor: pointer;
}
::ng-deep.item.feedback--colpro .cig_collab_img img {
  max-width: 100%;
  max-height: 300px;
}
::ng-deep.item.feedback--wn h2 {
  float: left;
  background: rgba(243, 243, 243, 0.3) !important;
  min-width: 200px;
  padding: 10px;
}
::ng-deep.item.feedback--wsyk .feedback-content .fs-logo-feedback {
  max-width: 350px;
  margin: 30px auto 0;
}
::ng-deep.item.feedback--wsyk .feedback-content .fs-logo-feedback img {
  max-width: 100%;
}
::ng-deep.item.feedback--au .feedback-content .profile-description {
  font-size: 17px;
}
::ng-deep.item.feedback--au .feedback-content .about-u {
  background: #F1F1F2;
  overflow: hidden;
  margin-bottom: 10px;
  padding: 10px;
}
::ng-deep.item.feedback--au .feedback-content .about-u .fix-label {
  background: #6D6E71;
  color: #fff;
  padding: 7px;
  font-family: "Museo-700";
  display: inline-block;
  vertical-align: top;
}
::ng-deep.item.feedback--au .feedback-content .about-u .right-label {
  display: block;
  margin-bottom: 10px;
  text-align: right;
}
::ng-deep.item.feedback--au .feedback-content .about-u .right-label span {
  padding: 8px;
  color: #fff;
}
::ng-deep.item.feedback--au .feedback-content .about-u .right-label .eq-developer {
  font-size: 16px;
}
::ng-deep.item.feedback--wc {
  color: #fff;
}
::ng-deep.item.feedback--bg {
  background-size: cover;
}
::ng-deep.item.feedback--bulbbg {
  background-color: #bfbfbf !important;
  background-size: cover;
}
::ng-deep.item.feedback--bulbbg h1 {
  position: absolute;
  top: 50%;
  text-align: center;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  line-height: 60px;
}
::ng-deep.item.feedback--mb .title-sm {
  margin-bottom: 30px;
}
::ng-deep.item.feedback--mt .high_prefer {
  top: 4px;
}
::ng-deep.item.feedback--mt .col-xs-5 {
  margin-top: 28px;
}
::ng-deep.item.feedback .feedback-test_result {
  max-width: 400px;
  margin: 0px auto;
  text-align: center;
}
@media only screen and (max-height: 414px) and (orientation: landscape) {
  ::ng-deep.item.feedback .feedback-test_result {
    transform: scale(0.8);
    margin-top: -15px;
  }
}
::ng-deep.item.feedback .feedback-test_result .big-profile {
  display: inline-block;
  transform: scale(3);
  transform-origin: right;
  margin: 20px 15px;
}
::ng-deep.item.feedback .feedback-test_result p {
  display: inline-block;
  background: #6D6E71;
  color: #fff;
  padding: 7px;
  margin: 0px 0 0 0;
  vertical-align: super;
  font-family: "Museo-700";
  position: relative;
  top: -9px;
}
::ng-deep.item .feedback-content {
  padding: 50px 50px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.item .feedback-content {
    padding: 20px;
  }
}
::ng-deep.item .feedback-content .f-sight {
  margin-top: 45px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.item .feedback-content .f-sight .col-xs-7 {
    width: 100%;
    margin-top: 10px;
  }
}
::ng-deep.item .feedback-content img {
  max-width: 500px;
  width: 100%;
}
::ng-deep.item .feedback-content h1.title {
  font-size: 38px;
  max-width: 30%;
  width: 100%;
  font-family: "Museo-300";
}
@media only screen and (max-width: 991px) {
  ::ng-deep.item .feedback-content h1.title {
    font-size: 30px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.item .feedback-content h1.title {
    font-size: 22px;
  }
}

::ng-deep body {
  --lmslider_size: 40px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep body.mini-navbar:not(.full-scr) {
    --lmslider_size: 30px;
  }
}

::ng-deep .lmslider {
  --clrLight: #eee;
  --clrDarkGrey: #6D6E71;
  --secPad: 30px;
  width: min(976px, 100%);
  margin: 0 auto !important;
  padding: 40px !important;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .lmslider {
    padding: 20px !important;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .lmslider {
    --secPad: 20px;
  }
}
::ng-deep .lmslider .lmslider {
  padding: 0 !important;
}
::ng-deep .lmslider__top {
  background-color: #eee;
  padding: var(--secPad);
  padding-bottom: calc(var(--secPad) + 10px);
}
@media only screen and (max-width: 991px) {
  ::ng-deep .lmslider__top {
    padding: 20px 20px 40px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .lmslider__top {
    padding: 0 0 40px;
  }
}
::ng-deep .lmslider__blocks {
  background-color: transparent;
  position: relative;
}
::ng-deep .lmslider__blocks ::ng-deep .video-mp4 video {
  height: 460px !important;
  cursor: pointer;
}
::ng-deep .lmslider__blocks ::ng-deep .youtube iframe {
  height: 512px;
  width: 100%;
}
::ng-deep .lmslider__img-wrapper {
  position: relative;
  padding-bottom: 56.25%;
}
.lmslider--swc ::ng-deep .lmslider__img-wrapper {
  padding-bottom: 0;
  min-height: 512px;
}
@media only screen and (max-width: 767px) {
  .lmslider--swc ::ng-deep .lmslider__img-wrapper {
    min-height: 240px;
  }
}
::ng-deep .lmslider__bg-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: bottom;
}
::ng-deep .lmslider .feedback-wrapper {
  position: relative;
}
::ng-deep .lmslider__slnum input {
  width: 30px;
  height: 22px;
  padding: 0;
  text-align: center;
  border: 1px solid #ada4a4;
  font-family: "Open Sans";
  color: inherit;
  border-radius: 0;
}
::ng-deep .lmslider__slnum input[type=number]::-webkit-outer-spin-button, ::ng-deep .lmslider__slnum input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
::ng-deep .lmslider__dots {
  position: absolute;
  bottom: -40px;
  left: 0;
  width: 100%;
  height: 45px;
  padding-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
::ng-deep .lmslider__dots--dot {
  display: flex;
  justify-content: center;
  align-items: center;
  list-style: none;
  padding-right: 11px;
  margin-bottom: 0;
  margin-top: 0;
}
::ng-deep .lmslider__dots--dot li {
  min-height: 5px;
  max-width: 5px;
  border-radius: 50%;
  background-color: #fff;
  width: 100%;
  margin-left: 3px;
  cursor: pointer;
  min-width: 5px;
}
::ng-deep .lmslider__dots--dot li.active {
  background-color: #6D6E71;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .lmslider__dots--dot {
    padding-inline: 0;
  }
}
::ng-deep .lmslider__ftr {
  width: 100%;
  background-color: #fff;
  padding: 10px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .lmslider__ftr {
    padding-inline: 0;
  }
}
::ng-deep .lmslider__ftr--pos {
  position: relative;
}
::ng-deep .lmslider__ftrrow {
  --flexGap: 10px;
  --flexGap-minus: calc(-1 * var(--flexGap));
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  margin: 0 var(--flexGap-minus);
  grid-row-gap: 8px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .lmslider__ftrrow {
    justify-content: center;
    --flexGap: 5px;
  }
}
::ng-deep .lmslider__ftrrow > div {
  padding-right: var(--flexGap);
  padding-left: var(--flexGap);
}
::ng-deep .lmslider__ftrrow .flex-1 {
  flex: 1;
}
::ng-deep .lmslider__ftrrow .flex-1--minw200 {
  min-width: 200px;
}
::ng-deep .lmslider__ftrauth img {
  width: var(--lmslider_size);
  height: var(--lmslider_size);
  border-radius: 50%;
}
::ng-deep .lmslider__ftrplayer {
  line-height: 0;
}
::ng-deep .lmslider__ftrplayer audio {
  width: 100%;
  height: var(--lmslider_size);
}
::ng-deep .lmslider__ftr_audio_player {
  line-height: 0;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .lmslider__ftr_audio_player_wrapper {
    flex: none !important;
    width: 100%;
    order: 1;
  }
}
::ng-deep .lmslider__ftr_audio_player audio {
  width: 100%;
  height: var(--lmslider_size);
}
::ng-deep .lmslider__ftrvol {
  width: var(--lmslider_size);
  height: var(--lmslider_size);
  background-color: var(--clrLight);
  border-radius: 50%;
  border: 0;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
::ng-deep .lmslider__ftrvol:hover {
  background-color: var(--clrDarkGrey);
  color: #fff;
}
::ng-deep .lmslider__ftrtextbtn--show {
  display: block;
}
::ng-deep .lmslider__ftrtextneg, ::ng-deep .lmslider__ftrtexthide {
  background-color: transparent;
  border: 0;
  font-size: 12px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 4px;
  transform: 0.3s;
  font-family: "Open sans";
  color: #676a63;
  cursor: pointer;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .lmslider__ftrtextneg, ::ng-deep .lmslider__ftrtexthide {
    padding: 1px;
  }
}
::ng-deep .lmslider__ftrtextneg i,
::ng-deep .lmslider__ftrtextneg img, ::ng-deep .lmslider__ftrtexthide i,
::ng-deep .lmslider__ftrtexthide img {
  margin-right: 8px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .lmslider__ftrtextneg i,
  ::ng-deep .lmslider__ftrtextneg img, ::ng-deep .lmslider__ftrtexthide i,
  ::ng-deep .lmslider__ftrtexthide img {
    margin-right: 2px;
  }
}
::ng-deep .lmslider__ftrtexthide svg {
  width: 16px;
  margin-right: auto;
  margin-left: 8px;
}
::ng-deep .lmslider__ftrarrows {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 10px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .lmslider__ftrarrows {
    grid-gap: 6px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .lmslider__ftrarrows_wrapper {
    margin-left: auto;
  }
}
::ng-deep .lmslider__ftrarrows a {
  width: var(--lmslider_size);
  height: var(--lmslider_size);
  font-size: 18px;
  background-color: transparent;
  border-radius: 50%;
  color: var(--clrDarkGrey);
  border: 1px solid var(--clrDarkGrey);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .lmslider__ftrarrows a {
    width: calc(var(--lmslider_size) - 6px);
    height: calc(var(--lmslider_size) - 6px);
    font-size: 12px;
  }
}
::ng-deep .lmslider__ftrarrows a:hover {
  background-color: var(--clrDarkGrey);
  color: #fff;
}
::ng-deep .lmslider__ftrarrows a svg {
  width: 46%;
  fill: #fff;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .lmslider__ftrarrows a svg {
    width: 38%;
  }
}
::ng-deep .lmslider__ftrarrows--anbtn a {
  background-color: var(--clrDarkGrey);
  color: #fff;
  opacity: 0.7;
}
::ng-deep .lmslider__ftr .hideftr-item {
  display: none;
}
::ng-deep .lmslider__notes {
  background-color: var(--clrLight);
  padding: var(--secPad);
  margin-top: var(--secPad);
  margin-top: 0px;
}

::ng-deep #page-wrapper {
  min-height: 100vh;
  padding-bottom: 70px;
}

.modal-body.p-event {
  pointer-events: all;
}

::ng-deep .full-scr .ibox.product-detail {
  margin: 0;
}
::ng-deep .full-scr #learner-map {
  display: none;
}
::ng-deep .full-scr .wrapper.wrapper-content {
  padding: 0;
}
::ng-deep .full-scr .ibox-content--bdr {
  padding: 0;
}
::ng-deep .full-scr div#page-wrapper {
  margin-left: 0px;
  z-index: 99999;
  padding: 0;
}
::ng-deep .full-scr .page-heading {
  display: none;
}
::ng-deep .full-scr .new-dashboard {
  display: none !important;
}
::ng-deep .full-scr .navbar-default {
  display: none;
}
::ng-deep .full-scr .lmslider {
  margin: 0;
  width: 100%;
  min-height: 100vh;
  background-color: #eee;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  z-index: 999;
}
::ng-deep .full-scr .lmslider ::ng-deep .lmslider {
  padding: 0;
  min-height: auto;
}
::ng-deep .full-scr .lmslider > * {
  width: 100%;
}
::ng-deep .full-scr .lmslider__ftr {
  padding-inline: 10px;
}
::ng-deep .full-scr .lmslider .slidemap-text img {
  max-height: 560px !important;
}
::ng-deep .full-scr .lmslider__ftrarrows .full-screen-icon {
  display: none !important;
}
::ng-deep .full-scr .lmslider__ftrplayer {
  line-height: 0;
}
::ng-deep .full-scr .lmslider__ftrtextneg_wrapper {
  display: none;
}
::ng-deep .full-scr .lmslider__top {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  width: min(1000px, 100%);
}
::ng-deep .full-scr .lmslider__top:not(:last-child) {
  margin-bottom: 20px;
}
::ng-deep .full-scr .lmslider__notes {
  margin-top: 0;
  padding: 0;
  width: 100%;
}
::ng-deep .full-scr .lmslider__notes_inner {
  width: min(1000px, 100%);
  margin-inline: auto;
}
::ng-deep .full-scr .lmslider__blocks {
  min-height: initial;
  width: 100%;
}
::ng-deep .full-scr .lmslider__blocks--full {
  height: 100%;
  min-height: initial;
}
::ng-deep .full-scr .lmslider__blocks--fullw {
  height: 90%;
  min-height: initial;
}
::ng-deep .full-scr .lmslider__blocks .video-mp4 video {
  object-fit: cover;
  position: absolute;
  height: 90% !important;
}
::ng-deep .full-scr .lmslider__blocks .lmslider__dots {
  display: none;
}
::ng-deep .full-scr .lmslider__blocks .lmslider__ftrtextneg {
  display: none;
}
::ng-deep .full-scr .lmslider__blocks .lmslider__ftrtextbtn {
  display: none;
}
::ng-deep .full-scr .item.feedback {
  min-height: initial;
  height: 100%;
  position: relative;
  width: 100%;
  max-width: 100%;
  background-size: 100%;
}
::ng-deep .full-scr footer,
::ng-deep .full-scr .footer {
  display: none;
}
::ng-deep .full-scr .exit-full-scr {
  display: flex !important;
}
::ng-deep .full-scr .lm-an-cards {
  display: none !important;
}
::ng-deep .full-scr .exit-full-scr {
  display: block;
}

.exit-full-scr {
  display: none;
}

.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: -ms-flexbox;
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100vh;
  margin: 0 auto;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.section-wrapper--lms {
  padding: 0;
}

.feedback--fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
  padding: 40px;
  background: #f8f8f9;
}
.feedback--fallback .feedback-fallback {
  max-width: 600px;
}
.feedback--fallback .feedback-fallback h2 {
  font-size: 28px;
  font-weight: 700;
  color: #4a4a4c;
  margin: 0 0 16px;
  font-family: "Museo-regular";
}
.feedback--fallback .feedback-fallback p {
  font-size: 16px;
  color: #676a6c;
  line-height: 1.6;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/learner-maps/dynamic-learner-map/dynamic-card-single/learner-map-slideshow/learner-map-slideshow.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA5YA;EA6FE,oCAAA;EAiCA,aAAA;EAUA,4BAAA;EA8CA,oBAAA;EAKA,QAAA;EAwBA,kCAAA;EAsCA,4DAAA;EACA,sCAAA;EAQA,sBAAA;EAyCA,iCAAA;EAaA,sBAAA;EA2BA,gCAAA;EA8RA,wBAAA;EAyEA,8BAAA;EAoHA,uBAAA;AAhZF;AA7ZE;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EAEA,8BAAA;EAEA,gBAAA;EACA,cAAA;EACA,WAAA;AA6ZJ;AA1ZE;;EAEE,eAAA;AA4ZJ;AAzZE;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EAEA,8BAAA;EACA,aAAA;EACA,kBAAA;EAEA,iBAAA;AAyZJ;AAtZE;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;EACA,8BAAA;EAEA,8BAAA;EAEA,cAAA;EACA,gBAAA;AAsZJ;AAnZE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,sBDmBe;EClBf,UAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,0CAAA;EACA,sBAAA;EACA,oCAAA;AAqZJ;AAlZE;EACE,+CAAA;EACA,2CAAA;AAoZJ;AAjZE;;EAEE,kBAAA;EACA,WDCe;ECAf,eAAA;EACA,WAAA;EACA,kBAAA;AAmZJ;AAhZE;EACE,WAAA;AAkZJ;AA/YE;EACE,YAAA;AAiZJ;AA9YE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA;kBAAA;EAEA;;YAAA;AAkZJ;AA5YE;EACE,gBAAA;EACA,WAAA;EACA,cAAA;EAEA,yCAAA;EAEA,qCAAA;AA8YJ;AA1YE;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,4BAAA;EACA,sBAAA;AA4YJ;AAzYE;EACE,cAAA;EACA,kBAAA;EAGA,gCAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AA2YJ;AAtYE;EACE,YAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;AAwYJ;AApYE;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;AAsYJ;AAnYE;EACE,aAAA;EACA,kBAAA;EACA,6CAAA;AAqYJ;AAlYE;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;AAoYJ;AAjYE;EAKE,oCAAA;AAmYJ;AAhYE;EACE,WAAA;AAkYJ;AA/XE;;EAEE,eAAA;AAiYJ;AA9XE;EACE,yBAAA;EAIA,iBAAA;EACA,6CAAA;AAgYJ;AA5XE;EACE,6FAAA;AA8XJ;AA1XE;;EAEE,mCAAA;EACA,gCAAA;EACA,+BAAA;EACA,uCAAA;EACA,oCAAA;EACA,mCAAA;AA4XJ;AAzXE;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AA2XJ;AAzXI;EACE;IACE,wBAAA;EA2XN;AACF;AArXE;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAuXJ;AApXE;EACE,eAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;AAsXJ;AAnXE;EACE,gBAAA;AAqXJ;AAlXE;EACE,gBAAA;AAoXJ;AA/WE;EACE,0BAAA;EACA,UAAA;EACA,UAAA;EACA,qBAAA;AAiXJ;AA5WE;EACE,qBAAA;EACA,OAAA;EACA,eAAA;EACA,kBAAA;AA8WJ;AA3WE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EAGA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;AA6WJ;AA3WI;EAbF;IAcI,eAAA;EA8WJ;AACF;AA3WE;;EAEE,oCAAA;EACA,0BAAA;EACA,UAAA;EACA,UAAA;AA6WJ;AA1WE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AA4WJ;AAvWE;EACE,YAAA;EACA,WAAA;EACA,WD3Oe;EC4Of,iBAAA;EACA,eAAA;EAGA,mBAAA;AAyWJ;AArWE;EACE,iBAAA;EACA,iHAAA;AAuWJ;AApWE;EACE;IACE,iBAAA;EAsWJ;EAnWE;IACE,eAAA;EAqWJ;EAlWE;IACE,kBAAA;IACA,YAAA;IACA,cAAA;EAoWJ;EAjWE;IACE,WAAA;EAmWJ;AACF;AA1VI;EACE,gBAAA;EACA,cAAA;AA4VN;AAxVE;EACE,uCAAA;EACA,iCAAA;EACA,6CAAA;AA0VJ;AAxVI;EACE,WD/Ra;ACynBnB;AAtVE;EACE,uCAAA;EACA,iCAAA;AAwVJ;AAtVI;EACE,WDxSa;ACgoBnB;AApVE;EACE,uCAAA;EACA,iCAAA;EACA,mCAAA;EACA,wCAAA;AAsVJ;AAnVE;EACE,uCAAA;EACA,oCAAA;EACA,mCAAA;EACA,6CAAA;AAqVJ;AAnVI;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EAGA,2BAAA;EACA,iBAAA;AAqVN;AAjVE;EACE,uCAAA;EACA,iCAAA;AAmVJ;AAjVI;EACE,WD3Ua;EC4Ub,WAAA;EACA,+CAAA;EACA,gBAAA;EACA,aAAA;AAmVN;AA/UE;EACE,uCAAA;EACA,iCAAA;AAiVJ;AA7UM;EACE,cAAA;AA+UR;AAtUM;EACE,gBAAA;AAwUR;AAjUI;EACE,mBAAA;AAmUN;AA9TE;EACE,gBAAA;AAgUJ;AA1TI;EACE,gBAAA;AA4TN;AAtTI;EACE,WAAA;EACA,eAAA;AAwTN;AAhTM;EACE,gBAAA;AAkTR;AA7SE;EACE,wBAAA;EACA,YAAA;EACA,YAAA;AA+SJ;AA5SE;EACE,oBAAA;AA8SJ;AA3SE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,+CAAA;EACA,qBAAA;AA6SJ;AA3SI;EARF;IASI,YAAA;EA8SJ;AACF;AArSM;EAPF;IAQI,aAAA;EAwSN;AACF;AApSI;EACE,oCAAA;EACA,mBAAA;EAGA,2BAAA;AAsSN;AApSM;EAPF;IAQI,oCAAA;EAuSN;AACF;AArSM;EAXF;IAYI,oCAAA;EAwSN;AACF;AAtSM;EAfF;IAgBI,mCAAA;EAySN;AACF;AAlSI;EACE,WAAA;AAoSN;AA/RI;EACE,mBAAA;AAiSN;AA1RI;EACE,uBAAA;AA4RN;AAzRI;;EAEE,cDlgBe;AC6xBrB;AAjRE;EAEE,8BAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AAkRJ;AAhRI;EACE,qBAAA;EACA,sBAAA;EACA,sBD5fa;EC6fb,kBD7fa;AC+wBnB;AA9QE;EACE,SAAA;EACA,UAAA;EACA,6BAAA;EACA,uBAAA;EACA,kCAAA;EACA,2BAAA;AAgRJ;AA7QE;EACE,uBAAA;EACA,6BAAA;EACA,yBAAA;EACA,WAAA;EACA,QAAA;EACA,6BAAA;EACA,0BAAA;AA+QJ;AA5QE;EACE,yBAAA;EACA,6BAAA;EACA,0BAAA;EACA,WAAA;EACA,SAAA;AA8QJ;AA1QI;EACE,iBAAA;AA4QN;AApQE;EACE;IACE,eAAA;EAsQJ;AACF;AAhQI;EACE,YAAA;EACA,WDjjBa;ECkjBb,eAAA;AAkQN;AA/PI;EACE,mBDrlBe;ECslBf,WDvjBa;ECwjBb,eAAA;EACA,YAAA;EACA,wBD5nBK;EC6nBL,qBAAA;EACA,mBAAA;AAiQN;AA9PI;EACE,mBD5lBgB;EC6lBhB,gBAAA;EACA,mBAAA;AAgQN;AA9PM;EACE,cAAA;EACA,mBAAA;EACA,iBAAA;AAgQR;AA3PE;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AA6PJ;AA3PI;EALF;IAUI,qBAAA;IACA,iBAAA;EA8PJ;AACF;AA5PI;EACE,qBAAA;AA8PN;AA3PI;EACE,qBAAA;EACA,mBD/nBe;ECgoBf,WDjmBa;ECkmBb,YAAA;EACA,SAAA;EACA,qBAAA;EACA,wBDvqBK;ACo6BX;AAxPI;EACE,eAAA;AA0PN;AAvPI;EACE,eAAA;EACA,kBAAA;EACA,WAAA;AAyPN;AApPE;EACE,UAAA;EACA,YAAA;EACA,uCAAA;AAsPJ;AApPI;EAEE,YAAA;EACA,mCAAA;AAqPN;AAjPE;EACE,2BAAA;AAmPJ;AAhPE;EACE,eAAA;AAkPJ;AA/OE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,cDlrBiB;ECmrBjB,YAAA;EACA,OAAA;EACA,QAAA;EACA,qBAAA;AAiPJ;AA/OI;EACE,cAAA;AAiPN;AA7OE;EACE,gBAAA;EACA,mBAAA;AA+OJ;AA3OI;EACE,eAAA;AA6ON;AA3OM;EAHF;IAII,iBAAA;IACA,gBAAA;IACA,gBAAA;EA8ON;AACF;AA5OM;EATF;IAUI,eAAA;IACA,iBAAA;EA+ON;EA7OM;IACE,iBAAA;EA+OR;AACF;AA5OM;EAlBF;IAmBI,iBAAA;EA+ON;AACF;AA7OM;EAtBF;IAuBI,4BAAA;IACA,0BAAA;EAgPN;AACF;AA7OI;EACE,eAAA;AA+ON;AA7OM;EAHF;IAII,eAAA;IACA,WAAA;EAgPN;AACF;AA7OI;EACE,aAAA;AA+ON;AA7OM;EAHF;IAII,kBAAA;EAgPN;EA9OM;IACE,eAAA;IACA,kBAAA;IACA,qBAAA;IACA,mBAAA;IACA,YAAA;IAEA,YAAA;EA+OR;AACF;AA3OI;EACE,eAAA;EACA,WDxtBa;ACq8BnB;AA3OM;EACE,YAAA;AA6OR;AA3OQ;EAHF;IAII,YAAA;IACA,eAAA;EA8OR;AACF;AAjOI;EACE,0GAAA;EACA,YAAA;EACA,YAAA;AAmON;AAhOI;EACE,4CAAA;AAkON;AA/NI;EACE,wCAAA;AAiON;AA9NI;EACE,wCAAA;AAgON;AA7NI;EACE,6CAAA;AA+NN;AA5NI;EACE,wCAAA;AA8NN;AA3NI;EACE,4CAAA;AA6NN;AA1NI;EACE,wCAAA;AA4NN;AAzNI;EACE,6CAAA;AA2NN;AAxNI;EACE,wCAAA;AA0NN;AAvNI;EACE,uCAAA;AAyNN;AAtNI;EACE,4CAAA;AAwNN;AArNI;EACE,6CAAA;EACA,eAAA;EACA,YAAA;AAuNN;AApNI;EACE,6CAAA;AAsNN;AAnNI;EACE,4CAAA;AAqNN;AAlNI;EACE,mCAAA;AAoNN;AA/ME;;EAEE,aAAA;AAiNJ;AA9ME;;EAEE,gBAAA;AAgNJ;AA7ME;;EAEE,wBAAA;AA+MJ;AA5ME;EACE,gBAAA;AA8MJ;AA5MI;EACE,qCAAA;EACA,sBAAA;AA8MN;AA1ME;EACE,sBAAA;EACA,gBAAA;AA4MJ;AA1MI;EACE,yBAAA;AA4MN;AAzMI;EACE,gBAAA;EACA,WAAA;EACA,YAAA;AA2MN;AAzMM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AA2MR;AAxMM;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AA0MR;AAvMM;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,4BAAA;EACA,0BAAA;AAyMR;AAtMM;EACE,2CAAA;EACA,qCAAA;EACA,sCAAA;EACA,mCAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;AAwMR;AApMI;EACE,2CAAA;EACA,0CAAA;EACA,uCAAA;AAsMN;AApMM;EACE,2BAAA;EACA,yBAAA;EAGA,iBAAA;EACA,SAAA;EACA,eAAA;AAsMR;AAlMI;EACE,sBAAA;EACA,gBAAA;EACA,kBAAA;AAoMN;AAjMI;EACE,WAAA;AAmMN;AAhMI;EACE,eAAA;AAkMN;AA/LI;EACE,yBAAA;EACA,cAAA;AAiMN;AA9LI;EACE,eAAA;AAgMN;AA7LI;EACE,eAAA;AA+LN;AA5LI;EACE,kBAAA;AA8LN;AA3LI;EACE,UAAA;EACA,UAAA;AA6LN;AAzLE;EACE,kBAAA;AA2LJ;AAzLI;EACE,qBAAA;EACA,eAAA;AA2LN;AAvLE;EAII;;IAEE,WAAA;EAsLN;EAnLI;IACE,0BAAA;EAqLN;EAlLI;IACE,eAAA;IACA,iBAAA;EAoLN;AACF;AAhLE;EAII;IACE,0BAAA;EA+KN;EA5KI;IACE,eAAA;IACA,iBAAA;EA8KN;AACF;AA1KE;EAII;;IAEE,WAAA;EAyKN;EAtKI;IACE,UAAA;IACA,UAAA;EAwKN;EArKI;IACE,mCAAA;IACA,qCAAA;EAuKN;EAlKM;IACE,kBAAA;EAoKR;AACF;AA/JE;EACE,iBAAA;EACA,sBAAA;EACA,iBAAA;AAiKJ;;AA3JA,sBAAA;AAEA;EACE,iBAAA;EACA,kBAAA;AA6JF;;AA1JA;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AA6JF;;AAxJE;EAFF;IAGI,gBAAA;IACA,eAAA;EA4JF;AACF;AA1JE;EACE,eAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBD5hCe;EC6hCf,OAAA;EACA,eAAA;EACA,YAAA;AA4JJ;AA1JI;EAXF;IAYI,kBAAA;IACA,gBAAA;EA6JJ;AACF;AAzJE;EACE,WAAA;AA2JJ;AAxJE;EACE,cAAA;EACA,WAAA;AA0JJ;AAvJE;EACE,eAAA;EACA,MAAA;EACA,SAAA;AAyJJ;AA3HE;EACE,gBAAA;EACA,WAAA;AA6HJ;AA3DQ;;EACE,gBAAA;EACA,WAAA;AA8DV;AA5DU;EAJF;;IAKI,gBAAA;EAgEV;AACF;;AAjDA;EACE,UAAA;EACA,gBAAA;AAoDF;;AAjDA;EACE;IACE,gBAAA;EAoDF;AACF;AAjDA;EACE;IACE,cAAA;IACA,gBAAA;EAmDF;AACF;AAhDA;EACE;IACE,gBAAA;IACA;;;;;;;;;;iBAAA;EA4DF;AACF;AA/CA;EAEI;IACE,eAAA;EAgDJ;EA7CE;IACE,eAAA;EA+CJ;EA5CE;IACE,eAAA;EA8CJ;EA3CE;IACE,eAAA;EA6CJ;EAxCM;IACE,eAAA;EA0CR;EAvCM;IACE,eAAA;EAyCR;EAtCM;IACE,WAAA;EAwCR;EApCI;IACE,mCAAA;EAsCN;AACF;AAhCE;EACE,eAAA;AAkCJ;AA/BE;EACE,8BAAA;AAiCJ;AA/BI;EAHF;IAII,8BAAA;EAkCJ;AACF;AA9BE;EACE,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AAgCJ;AA9BI;EANF;IAOI,WAAA;EAiCJ;AACF;;AA5BA;EACE;IACE,gBAAA;EA+BF;AACF;AA5BA;EAGI;;IAEE,WAAA;EA4BJ;EAzBE;IACE,oBAAA;EA2BJ;EAxBE;;IAEE,0BAAA;IACA,WAAA;EA0BJ;EAvBE;IACE,6BAAA;EAyBJ;EAtBE;IACE,UAAA;EAwBJ;EAjBE;IACE,iBAAA;EAmBJ;EAjBI;IACE,UAAA;IACA,WAAA;IACA,WAAA;EAmBN;EAfE;IACE,QAAA;IACA,UAAA;EAiBJ;AACF;AAXA;EAEI;IACE,qBAAA;EAYJ;EATE;IACE,qBAAA;EAWJ;EAPA;IACE,kBAAA;EASF;EANA;;IAEE,qBAAA;IACA,sBAAA;IACA,UAAA;EAQF;EALA;IACE,WAAA;IACA,gBAAA;EAOF;EALE;IACE,4BAAA;EAOJ;EAJE;IACE,oCAAA;IACA,6CAAA;EAMJ;EAHE;IACE,iBAAA;EAKJ;EAFE;IACE,0BAAA;EAIJ;EAAI;IACE,0BAAA;IACA,2BAAA;EAEN;EAEM;IACE,0BAAA;IACA,kBAAA;EAAR;EAGM;IACE,gBAAA;EADR;EAIM;IACE,0BAAA;EAFR;EAKM;IACE,0BAAA;EAHR;EAMM;IACE,UAAA;EAJR;EAOM;IACE,gBAAA;IACA,gBAAA;EALR;EAOQ;IACE,eAAA;EALV;EAQQ;IACE,gBAAA;IACA,gBAAA;EANV;EAQU;IACE,YAAA;IACA,kBAAA;EANZ;EAYI;IAKE,sBAAA;IACA,iBAAA;IACA,WAAA;EAVN;EAaI;;;;IAQE,qBAAA;EAXN;EAeM;IACE,gBAAA;EAbR;AACF;AAoBE;EACE,eAAA;AAlBJ;AAuBE;EACE,UAAA;EACA,UAAA;AArBJ;AAuBI;EAJF;IAKI,UAAA;IACA,2BAAA;IACA,qBAAA;IACA,WAAA;EApBJ;AACF;AAsBI;EAXF;IAYI,UAAA;IACA,2BAAA;EAnBJ;EAqBI;IACE,UAAA;EAnBN;AACF;AAwBI;EACE;IACE,cAAA;IACA,qBAAA;IACA,kBAAA;IACA,WAAA;EAtBN;EA0BM;IACE,WAAA;EAxBR;AACF;AA6BE;EACE,gBAAA;AA3BJ;;AAgCA;EACE,gBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,wBD9jDS;EC+jDT,gBD1/CiB;AC69CnB;AA+BE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,wBDlkDO;ACqiDX;AAgCE;EACE,eAAA;EAUA,kBAAA;EACA,gBAAA;EACA,wBDrlDO;AC8iDX;AA6BI;EAHF;IAII,eAAA;EA1BJ;AACF;AA4BI;EAPF;IAQI,eAAA;EAzBJ;AACF;AAgCE;EACE,aAAA;EACA,eAAA;EACA,oBAAA;AA9BJ;AAgCI;EACE,UAAA;EACA,oBAAA;AA9BN;AAgCM;EAJF;IAKI,UAAA;EA7BN;AACF;AAiCE;EACE,eAAA;AA/BJ;AAkCE;EACE,mBAAA;EACA,WAAA;AAhCJ;AAkCI;EACE,eAAA;EACA,iBAAA;AAhCN;AAkCM;EAJF;IAKI,eAAA;EA/BN;EAiCM;IACE,eAAA;EA/BR;AACF;;AAsCA;EAII;IACE,0BAAA;IACA,mBAAA;EAtCJ;EAyCE;IACE,eAAA;IACA,4BAAA;EAvCJ;EA8CI;IACE,0BAAA;EA5CN;EA+CI;IACE,eAAA;IACA,4BAAA;EA7CN;AACF;AAkDA;EAGM;IACE,iBAAA;EAlDN;EAwDM;IACE,8BAAA;IACA,0BAAA;EAtDR;EAyDM;IACE,0BAAA;EAvDR;EA0DM;IACE,0BAAA;IACA,2BAAA;EAxDR;EA2DM;IACE,0BAAA;EAzDR;EA4DM;IACE,0BAAA;IACA,kBAAA;EA1DR;EA8DQ;IACE,gBAAA;EA5DV;EAgEM;IAKE,qBAAA;IACA,iBAAA;EA9DR;EAkEI;IACE,iBAAA;EAhEN;AACF;AAsEA;EAEE;IACE,sBAAA;EArEF;EAwEA;IACE,WAAA;IACA,YAAA;IACA,iCAAA;IACA,8BAAA;IACA,gBAAA;IACA,eAAA;EAtEF;EAyEA;IACE,sBAAA;EAvEF;EA0EA;IACE,sBAAA;EAxEF;EA2EA;IACE,4BAAA;EAzEF;EA6EE;IACE,0BAAA;EA3EJ;EA8EE;IACE,4BAAA;EA5EJ;EA+EE;IACE,sBAAA;IACA,sBAAA;IACA,2BAAA;IAEA,WAAA;IACA,oCAAA;IAEA,yBAAA;IACA,qCAAA;EA/EJ;EAkFE;IACE,oCAAA;IACA,sBAAA;EAhFJ;EAmFE;;IAEE,sBAAA;IACA,8BAAA;IACA,8BAAA;IACA,qBAAA;IACA,sBAAA;EAjFJ;EAoFE;IACE,iGAAA;EAlFJ;EAqFE;IACE,8FAAA;EAnFJ;EAsFE;IACE,gGAAA;EApFJ;EAuFE;IACE,+FAAA;EArFJ;EAwFE;IACE,2FAAA;EAtFJ;EAyFE;IACE,2FAAA;EAvFJ;EA0FE;IACE,wBAAA;EAxFJ;EA2FE;IACE,wBAAA;EAzFJ;EA6FA;IACE,wBAAA;EA3FF;AACF;AA+FA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;AA7FF;;AAgGA;EACE,0BAAA;EACA,gBAAA;EACA,wBAAA;AA7FF;AA+FE;EACE,iBAAA;EACA,gBAAA;AA7FJ;;AAmGA;EAGE,aAAA;EAEA,eAAA;EAGA,mBAAA;AAhGF;;AAoGE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;AAjGJ;AAmGI;EANF;IAOI,aAAA;EAhGJ;AACF;AAkGI;EAVF;IAWI,WAAA;EA/FJ;AACF;AAiGI;EAdF;IAeI,gBAAA;EA9FJ;AACF;;AAkGA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kCAAA;EACA,8BAAA;EACA,yBAAA;AA/FF;AAiGE;EACE,2BAAA;AA/FJ;AAkGE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAhGJ;AAmGE;EAtBF;IAuBI,YAAA;EAhGF;AACF;AAkGE;EA1BF;IA2BI,WAAA;EA/FF;AACF;;AAoGA;EACE,YAAA;AAjGF;;AAuGI;EAFF;IAGI,aAAA;EAnGJ;AACF;;AA0GE;EAEE,4BAAA;EACA,sBAAA;EACA,2BAAA;EAEA,6BAAA;AAzGJ;AA2GI;EAEE,0BAAA;AA1GN;AA6GI;EACE,sBAAA;AA3GN;AA8GI;EACE,gBAAA;AA5GN;AAoHQ;EACE,eAAA;EACA,mBAAA;AAlHV;AAqHQ;EACE,mBAAA;AAnHV;AAsHQ;EACE,eAAA;EACA,kBAAA;EACA,WAAA;AApHV;AAyHU;EACE,WAAA;EACA,eAAA;AAvHZ;AAkIQ;EACE,eAAA;EACA,iBAAA;AAhIV;AAuIM;EACE,WAAA;EACA,+CAAA;EACA,gBAAA;EACA,aAAA;AArIR;AA6IQ;EACE,gBAAA;EACA,mBAAA;AA3IV;AA6IU;EACE,eAAA;AA3IZ;AAwJQ;EACE,eAAA;AAtJV;AAyJQ;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AAvJV;AAyJU;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,qBAAA;EACA,mBAAA;AAvJZ;AA0JU;EACE,cAAA;EACA,mBAAA;EACA,iBAAA;AAxJZ;AA0JY;EACE,YAAA;EACA,WAAA;AAxJd;AA2JY;EACE,eAAA;AAzJd;AAgKI;EACE,WAAA;AA9JN;AAiKI;EACE,sBAAA;AA/JN;AAkKI;EACE,oCAAA;EACA,sBAAA;AAhKN;AAkKM;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,iBAAA;AAhKR;AAsKM;EACE,mBAAA;AApKR;AA0KM;EACE,QAAA;AAxKR;AA2KM;EACE,gBAAA;AAzKR;AA8KI;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AA5KN;AA8KM;EALF;IAUI,qBAAA;IACA,iBAAA;EA3KN;AACF;AA6KM;EACE,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AA3KR;AAqLM;EACE,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,SAAA;AAnLR;AA0LE;EACE,kBAAA;AAxLJ;AA0LI;EAHF;IAII,aAAA;EAvLJ;AACF;AAyLI;EACE,gBAAA;AAvLN;AAyLM;EAEE;IACE,WAAA;IACA,gBAAA;EAxLR;AACF;AA4LI;EACE,gBAAA;EACA,WAAA;AA1LN;AA+LM;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,wBDvpEG;AC09DX;AA+LQ;EANF;IAOI,eAAA;EA5LR;AACF;AA8LQ;EAVF;IAWI,eAAA;EA3LR;AACF;;AAqNE;EACE,qBAAA;AAlNJ;AAwNQ;EAFF;IAGI,qBAAA;EArNR;AACF;;AA6NA;EACE,gBAAA;EACA,sBAAA;EACA,cAAA;EAEA,uBAAA;EACA,yBAAA;EACA,wBAAA;AA3NF;AA6NE;EATF;IAUI,wBAAA;EA1NF;AACF;AA4NE;EAbF;IAcI,cAAA;EAzNF;AACF;AA2NE;EACE,qBAAA;AAzNJ;AA8NE;EACE,sBAAA;EACA,sBAAA;EACA,0CAAA;AA5NJ;AA8NI;EALF;IAMI,uBAAA;EA3NJ;AACF;AA6NI;EATF;IAUI,iBAAA;EA1NJ;AACF;AA8NE;EACE,6BAAA;EACA,kBAAA;AA5NJ;AAgOM;EACE,wBAAA;EACA,eAAA;AA9NR;AAoOM;EACE,aAAA;EACA,WAAA;AAlOR;AAwOE;EACE,kBAAA;EACA,sBAAA;AAtOJ;AAwOI;EACE,iBAAA;EACA,iBAAA;AAtON;AAyOI;EAEE;IACE,iBAAA;EAxON;AACF;AA6OE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AA3OJ;AA+OE;EACE,kBAAA;AA7OJ;AAkPI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,cAAA;EACA,gBAAA;AAhPN;AAoPQ;EAEE,wBAAA;EACA,SAAA;AAnPV;AA0PE;EACE,kBAAA;EACA,aAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAxPJ;AA2PI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAzPN;AA2PM;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAzPR;AA2PQ;EACE,yBAAA;AAzPV;AA6PM;EAxBF;IAyBI,iBAAA;EA1PN;AACF;AA8PE;EACE,WAAA;EACA,sBAAA;EACA,aAAA;AA5PJ;AA8PI;EALF;IAMI,iBAAA;EA3PJ;AACF;AA6PI;EACE,kBAAA;AA3PN;AA8PI;EACE,eAAA;EACA,0CAAA;EA7MJ,aAAA;EACA,eAAA;EACA,mBAAA;EA6MI,yBAAA;EACA,8BAAA;EACA,iBAAA;AA1PN;AA4PM;EARF;IASI,uBAAA;IACA,cAAA;EAzPN;AACF;AA2PM;EACE,6BAAA;EACA,4BAAA;AAzPR;AA4PM;EACE,OAAA;AA1PR;AA4PQ;EACE,gBAAA;AA1PV;AAiQM;EACE,2BAAA;EACA,4BAAA;EACA,kBAAA;AA/PR;AAmQI;EACE,cAAA;AAjQN;AAmQM;EACE,WAAA;EACA,4BAAA;AAjQR;AAqQI;EACE,cAAA;AAnQN;AAuQQ;EAFF;IAGI,qBAAA;IACA,WAAA;IACA,QAAA;EApQR;AACF;AAuQM;EACE,WAAA;EACA,4BAAA;AArQR;AAyQI;EACE,2BAAA;EACA,4BAAA;EACA,iCAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EA1QJ,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AAIF;AAsQM;EACE,oCAAA;EACA,WAAA;AApQR;AA0QM;EACE,cAAA;AAxQR;AA4QI;EAEE,6BAAA;EACA,SAAA;EACA,eAAA;EApSJ,aAAA;EACA,eAAA;EACA,mBAAA;EAoSI,YAAA;EACA,eAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;AAzQN;AA2QM;EAZF;IAaI,YAAA;EAxQN;AACF;AA0QM;;;EAEE,iBAAA;AAvQR;AAyQQ;EAJF;;;IAKI,iBAAA;EApQR;AACF;AA0QM;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AAxQR;AA4QI;EACE,aAAA;EACA,eAAA;EACA,cAAA;AA1QN;AA4QM;EALF;IAMI,aAAA;EAzQN;AACF;AA6QQ;EAFF;IAGI,iBAAA;EA1QR;AACF;AA6QM;EACE,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;EACA,yBAAA;EACA,oCAAA;EApVN,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AA0EF;AA0QQ;EAVF;IAWI,uCAAA;IACA,wCAAA;IACA,eAAA;EAvQR;AACF;AAyQQ;EACE,oCAAA;EACA,WAAA;AAvQV;AA0QQ;EACE,UAAA;EACA,UAAA;AAxQV;AA0QU;EAJF;IAKI,UAAA;EAvQV;AACF;AA6QQ;EACE,oCAAA;EACA,WAAA;EACA,YAAA;AA3QV;AAiRI;EACE,aAAA;AA/QN;AAoRE;EACE,iCAAA;EACA,sBAAA;EACA,yBAAA;EAEA,eAAA;AAnRJ;;AAuRA;EACE,iBAAA;EACA,oBAAA;AApRF;;AAyRE;EACE,mBAAA;AAtRJ;;AA8RI;EACE,SAAA;AA3RN;AA+RE;EACE,aAAA;AA7RJ;AAiSE;EACE,UAAA;AA/RJ;AAkSE;EACE,UAAA;AAhSJ;AAmSE;EACE,gBAAA;EACA,cAAA;EACA,UAAA;AAjSJ;AAoSE;EACE,aAAA;AAlSJ;AAqSE;EACE,wBAAA;AAnSJ;AAsSE;EACE,aAAA;AApSJ;AAuSE;EACE,SAAA;EACA,WAAA;EACA,iBAAA;EACA,sBD1jFM;EC2jFN,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AArSJ;AAuSI;EACE,UAAA;EACA,gBAAA;AArSN;AAwSI;EACE,WAAA;AAtSN;AAySI;EACE,oBAAA;AAvSN;AA0SI;EACE,4BAAA;AAxSN;AA6SM;EACE,wBAAA;AA3SR;AA+SI;EACE,cAAA;AA7SN;AAgTI;EACE,aAAA;AA9SN;AAkTI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,wBAAA;AAhTN;AAkTM;EACE,mBAAA;AAhTR;AAoTI;EACE,aAAA;EACA,UAAA;EACA,WAAA;AAlTN;AAoTM;EACE,wBAAA;EACA,mBAAA;AAlTR;AAsTI;EACE,mBAAA;EACA,WAAA;AApTN;AAsTM;EACE,YAAA;EACA,mBAAA;AApTR;AAuTM;EACE,WAAA;EACA,mBAAA;AArTR;AA0TQ;EACE,iBAAA;EACA,kBAAA;EACA,sBAAA;AAxTV;AA8TQ;EACE,aAAA;AA5TV;AAiUU;EACE,aAAA;AA/TZ;AAkUU;EACE,aAAA;AAhUZ;AAyUI;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;AAvUN;AA2UE;;EAEE,aAAA;AAzUJ;AA4UE;EACE,wBAAA;AA1UJ;AA6UE;EACE,wBAAA;AA3UJ;AA8UE;EACE,cAAA;AA5UJ;;AAiVA;EACE,aAAA;AA9UF;;AAmVA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EAEA,oBAAA;EACA,aAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AAhVF;;AAmVA;EACE,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AAhVF;;AAmVA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAhVF;;AAoVA;EACE,mCAAA;EACA,UAAA;AAjVF;;AAoVA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AAjVF;;AAoVA;EACE,mCAAA;EACA,mBAAA;EACA,UAAA;AAjVF;;AAoVA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AAjVF;;AAoVA;EACE;IACE,UAAA;EAjVF;EAoVA;IACE,UAAA;EAlVF;EAqVA;IACE,UAAA;EAnVF;AACF;AAuVA;EACE,UAAA;AArVF;;AAyVA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAtVF;AAwVE;EACE,gBAAA;AAtVJ;AAwVI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,4BDh2FK;AC0gFX;AAyVI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAvVN","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","// Font\n@import './../../../../../../assets/styles/variables';\n\n::ng-deep .cig-parent-wrapper {\n  #nav {\n    position: relative;\n    z-index: 5000;\n    text-align: center;\n\n    background: rgba(0, 0, 0, 0.6);\n\n    max-width: 920px;\n    margin: 0 auto;\n    width: 100%;\n  }\n\n  #nav #prevtBtn,\n  #nav #nextBtn {\n    cursor: pointer;\n  }\n\n  .feedback-slider {\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n    height: 100%;\n\n    flex-direction: column-reverse;\n    display: flex;\n    margin-top: -100px;\n\n    min-height: 685px;\n  }\n\n  #Dots {\n    position: absolute;\n    z-index: 5000;\n    bottom: 12px;\n    left: 50%;\n    transform: translate(-50%, 0%);\n\n    background: rgba(0, 0, 0, 0.1);\n\n    z-index: 99999;\n    max-width: 855px;\n  }\n\n  .Dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    position: relative;\n    float: left;\n    background-color: $color-light-type;\n    opacity: 1;\n    margin: 5px;\n    margin-bottom: 0px;\n    cursor: pointer;\n    border: 2px solid rgba(255, 255, 255, 0.7);\n    background-color: #666;\n    border: 2px solid rgba(0, 0, 0, 0.7);\n  }\n\n  .Dot:first-child {\n    background-color: rgba(0, 0, 0, .5) !important;\n    border-color: rgba(0, 0, 0, .5) !important;\n  }\n\n  #prevtBtn,\n  #nextBtn {\n    /*color: #666767;*/\n    color: $color-light-type;\n    font-size: 33px;\n    margin: 0px;\n    position: relative;\n  }\n\n  #prevtBtn {\n    float: left;\n  }\n\n  #nextBtn {\n    float: right;\n  }\n\n  .feedback {\n    width: 100%;\n    height: auto;\n    font-size: 40px;\n    /*position: absolute;\n    /*color: white;*/\n    /*top:15%;\n    bottom:70px;\n    left:0px;*/\n  }\n\n  /*--------owl carousel ------------*/\n  #owl-demo {\n    max-width: 980px;\n    width: 100%;\n    margin: 0 auto;\n    -webkit-box-shadow: 0px 0px 39px -5px $body-content-color;\n    -ms-box-shadow: 0px 0px 39px -5px $body-content-color;\n    -moz-box-shadow: 0px 0px 39px -5px $body-content-color;\n    box-shadow: 0px 0px 39px -5px $body-content-color;\n  }\n\n\n  #owl-demo .item {\n    display: block;\n    width: 100%;\n    min-height: 515px;\n    background-repeat: no-repeat;\n    background-size: cover;\n  }\n\n  #owl-demo .item .feedback-wrapper {\n    display: block;\n    position: absolute;\n    -webkit-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    left: 50%;\n    top: 50%;\n    width: 100%;\n    height: 100%;\n  }\n\n\n  /* clearfix */\n  .owl-carousel .owl-wrapper:after {\n    content: \".\";\n    display: block;\n    clear: both;\n    visibility: hidden;\n    line-height: 0;\n    height: 0;\n  }\n\n  /* display none until init */\n  .owl-carousel {\n    display: none;\n    position: relative;\n    width: 100%;\n    -ms-touch-action: pan-y;\n  }\n\n  .owl-carousel .owl-wrapper {\n    display: none;\n    position: relative;\n    -webkit-transform: translate3d(0px, 0px, 0px);\n  }\n\n  .owl-carousel .owl-wrapper-outer {\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n  }\n\n  .owl-carousel .owl-wrapper-outer.autoHeight {\n    -webkit-transition: height 500ms ease-in-out;\n    -moz-transition: height 500ms ease-in-out;\n    -ms-transition: height 500ms ease-in-out;\n    -o-transition: height 500ms ease-in-out;\n    transition: height 500ms ease-in-out;\n  }\n\n  .owl-carousel .owl-item {\n    float: left;\n  }\n\n  .owl-controls .owl-page,\n  .owl-controls .owl-buttons div {\n    cursor: pointer;\n  }\n\n  .owl-controls {\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  }\n\n  /* mouse grab icon */\n  .grabbing {\n    cursor: url(https://cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/grabbing.png) 8 8, move;\n  }\n\n  /* fix */\n  .owl-carousel .owl-wrapper,\n  .owl-carousel .owl-item {\n    -webkit-backface-visibility: hidden;\n    -moz-backface-visibility: hidden;\n    -ms-backface-visibility: hidden;\n    -webkit-transform: translate3d(0, 0, 0);\n    -moz-transform: translate3d(0, 0, 0);\n    -ms-transform: translate3d(0, 0, 0);\n  }\n\n  .owl-theme .owl-controls {\n    margin-top: -20px;\n    text-align: center;\n    position: relative;\n    z-index: 999999;\n\n    @media only screen and (max-width: 991px) {\n      .owl-pagination {\n        display: none !important;\n      }\n    }\n  }\n\n  /* Styling Next and Prev buttons */\n\n  .owl-theme .owl-controls .owl-buttons div {\n    position: relative;\n    display: inline-block;\n    zoom: 1;\n    display: inline;\n    /*IE7 life-saver */\n    margin: 5px 2px;\n    overflow: hidden;\n    width: 40px;\n    height: 45px;\n    line-height: 45px;\n    font-size: 0px;\n  }\n\n  .owl-theme .owl-controls .owl-buttons div:before {\n    font-size: 40px;\n    font-family: \"FontAwesome\";\n    display: inline-block;\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    filter: Alpha(Opacity=70);\n    /*IE7 fix*/\n    opacity: 0.7;\n  }\n\n  .owl-theme .owl-controls .owl-buttons div.owl-prev:before {\n    content: \"\\f137\";\n  }\n\n  .owl-theme .owl-controls .owl-buttons div.owl-next:before {\n    content: \"\\f138\";\n  }\n\n  /* Clickable class fix problem with hover on touch devices */\n  /* Use it for non-touch hover action */\n  .owl-theme .owl-controls.clickable .owl-buttons div:hover:before {\n    filter: Alpha(Opacity=100);\n    /*IE7 fix*/\n    opacity: 1;\n    text-decoration: none;\n  }\n\n  /* Styling Pagination*/\n\n  .owl-theme .owl-controls .owl-page {\n    display: inline-block;\n    zoom: 1;\n    display: inline;\n    /*IE7 life-saver */\n  }\n\n  .owl-theme .owl-controls .owl-page span {\n    display: block;\n    width: 8px;\n    height: 8px;\n    margin: 4px;\n    -webkit-border-radius: 20px;\n    -moz-border-radius: 20px;\n    border-radius: 20px;\n    background: #6c6c6c !important;\n    filter: Alpha(Opacity=50);\n    /*IE7 fix*/\n    opacity: 0.5;\n\n    @media (max-width:860px) {\n      margin: 4px 3px;\n    }\n  }\n\n  .owl-theme .owl-controls .owl-page.active span,\n  .owl-theme .owl-controls.clickable .owl-page:hover span {\n    background-color: #3b3937 !important;\n    filter: Alpha(Opacity=100);\n    /*IE7 fix*/\n    opacity: 1;\n  }\n\n  .owl-buttons {\n    position: absolute;\n    right: 15px;\n    top: -40px;\n  }\n\n  /* If PaginationNumbers is true */\n\n  .owl-theme .owl-controls .owl-page span.owl-numbers {\n    height: auto;\n    width: auto;\n    color: $color-light-type;\n    padding: 2px 10px;\n    font-size: 12px;\n    -webkit-border-radius: 30px;\n    -moz-border-radius: 30px;\n    border-radius: 30px;\n  }\n\n  /* preloading images */\n  .owl-item.loading {\n    min-height: 150px;\n    background: url(https://cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/AjaxLoader.gif) no-repeat center center;\n  }\n\n  @media(max-width:767px) {\n    #owl-demo .item {\n      min-height: 475px;\n    }\n\n    .owl-theme .owl-controls {\n      margin-top: 0px;\n    }\n\n    .owl-buttons {\n      position: relative;\n      top: inherit;\n      right: inherit;\n    }\n\n    .owl-theme .owl-controls .owl-page span {\n      margin: 2px;\n    }\n  }\n\n  // ===========================================================\n  /* Style-for-interpretive-short*/\n\n\n  .feedback-page {\n\n    .wrapper-content {\n      max-height: 80vh;\n      overflow: auto;\n    }\n  }\n\n  #feed-banner {\n    background-repeat: no-repeat !important;\n    background-size: cover !important;\n    background-position: center center !important;\n\n    .title {\n      color: $color-light-type;\n    }\n  }\n\n  #great-mind {\n    background-repeat: no-repeat !important;\n    background-size: cover !important;\n\n    .title-sm {\n      color: $color-light-type;\n    }\n  }\n\n  #think {\n    background-repeat: no-repeat !important;\n    background-color: $color-light-type !important;\n    background-size: contain !important;\n    background-position: left 62% !important;\n  }\n\n  #f-bulb {\n    background-repeat: no-repeat !important;\n    background-color: #bfbfbf !important;\n    background-size: initial !important;\n    background-position: center center !important;\n\n    .title {\n      position: absolute;\n      top: 50%;\n      text-align: center;\n      left: 0;\n      right: 0;\n      -webkit-transform: translateY(-50%);\n      -ms-transform: translateY(-50%);\n      transform: translateY(-50%);\n      line-height: 60px;\n    }\n  }\n\n  #f-now {\n    background-repeat: no-repeat !important;\n    background-size: cover !important;\n\n    .title-sm {\n      color: $color-light-type;\n      float: left;\n      background: rgba(243, 243, 243, .3) !important;\n      min-width: 200px;\n      padding: 10px;\n    }\n  }\n\n  #f-end {\n    background-repeat: no-repeat !important;\n    background-size: cover !important;\n\n    .feedback-content {\n\n      img {\n        margin: 20px 0;\n      }\n    }\n  }\n\n  #congo {\n\n    .feedback-content {\n\n      img {\n        margin: 0 0 20px;\n      }\n    }\n  }\n\n  #f4-stage {\n\n    .title-sm {\n      margin-bottom: 30px;\n    }\n\n  }\n\n  .f-sight {\n    margin-top: 45px;\n\n  }\n\n  .f-score {\n\n    .col-xs-5 {\n      margin-top: 28px;\n    }\n  }\n\n  .s-icon {\n\n    .fa {\n      margin: 5px;\n      cursor: pointer;\n    }\n  }\n\n  #f-fit {\n\n    .feedback-content {\n\n      img {\n        max-width: 450px;\n      }\n    }\n  }\n\n  .feedback-player {\n    width: calc(100% - 65px);\n    float: right;\n    padding: 5px;\n  }\n\n  .feedback-content {\n    padding: 50px 50px 0;\n  }\n\n  .feedback-footer {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: rgba(243, 243, 243, .8) !important;\n    padding: 5px 5px 32px;\n\n    @media only screen and (max-width: 991px) {\n      padding: 5px;\n    }\n\n    .feed-logo {\n      &+.feed-logo {\n        //margin-left:-12px;\n\n\n      }\n\n      @media(max-width:767px) {\n        display: none;\n      }\n\n    }\n\n    audio {\n      width: calc(100% - 335px) !important;\n      margin-bottom: -3px;\n      -webkit-backface-visibility: hidden;\n      -ms-backface-visibility: hidden;\n      backface-visibility: hidden;\n\n      @media only screen and (max-width: 991px) {\n        width: calc(100% - 205px) !important;\n      }\n\n      @media only screen and (max-width: 767px) {\n        width: calc(100% - 175px) !important;\n      }\n\n      @media only screen and (max-width: 575px) {\n        width: calc(100% - 60px) !important;\n      }\n\n      // @media (max-width:767px){\n      //   width: 100% !important;\n      // }\n    }\n\n    .author-logo {\n      float: left;\n    }\n  }\n\n  .feedback {\n    .feedback-wrapper {\n      top: 50% !important;\n    }\n\n    // audio::-webkit-media-controls-panel {\n    //   background: transparent;\n    // }\n\n    audio::-moz-media-controls-panel {\n      background: transparent;\n    }\n\n    audio::-webkit-media-controls-current-time-display,\n    audio::-webkit-media-controls-time-remaining-display {\n      color: $body-content-color;\n    }\n\n    // audio::-webkit-media-controls-volume-slider,\n    // audio::-webkit-media-controls-mute-button,\n    // audio::-webkit-media-controls-volume-slider-container {\n    //   display: none;\n    // }\n  }\n\n  div#Dots {\n    // position: relative;\n    /*background: rgba(0,0,0,.4);*/\n    text-align: left;\n    width: 100%;\n    display: block;\n    bottom: 74px;\n    padding: 0px;\n    padding-left: 8%;\n    background: transparent;\n    /*max-width:920px;*/\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    transform: none;\n\n    .Dot {\n      display: inline-block;\n      float: none !important;\n      background-color: $color-light-type;\n      border-color: $color-light-type;\n    }\n  }\n\n  #nav {\n    left: 0px;\n    right: 0px;\n    position: absolute !important;\n    bottom: 90px !important;\n    background: transparent !important;\n    max-width: 980px !important;\n  }\n\n  #prevtBtn {\n    float: right !important;\n    margin-right: 60px !important;\n    color: #6c6c6c !important;\n    bottom: 0px;\n    right: 0;\n    position: absolute !important;\n    font-size: 40px !important;\n  }\n\n  #nextBtn {\n    color: #6c6c6c !important;\n    position: absolute !important;\n    font-size: 40px !important;\n    right: 20px;\n    bottom: 0;\n  }\n\n  .cig_collab_img {\n    img {\n      max-height: 300px;\n    }\n  }\n\n\n\n\n\n  @media only screen and (max-width:599px) {\n    .feedback p {\n      font-size: 15px;\n    }\n  }\n\n  /* dynamic-style-update*/\n  .feedback {\n\n    .right-label-text .eq-developer {\n      padding: 7px;\n      color: $color-light-type;\n      font-size: 16px;\n    }\n\n    .fix-label {\n      background: $color-neutral-dark;\n      color: $color-light-type;\n      font-size: 28px;\n      padding: 7px;\n      font-family: $muso-700;\n      display: inline-block;\n      vertical-align: top;\n    }\n\n    .about-u {\n      background: $color-neutral-light;\n      overflow: hidden;\n      margin-bottom: 10px;\n\n      .right-label {\n        display: block;\n        margin-bottom: 10px;\n        text-align: right;\n      }\n    }\n  }\n\n  .feedback-test_result {\n    max-width: 400px;\n    margin: 0px auto;\n    text-align: center;\n\n    @media only screen and (max-height: 414px) and (orientation:landscape) {\n      -webkit-transform: scale(0.8);\n      -moz-transform: scale(0.8);\n      -ms-transform: scale(0.8);\n      -o-transform: scale(0.8);\n      transform: scale(0.8);\n      margin-top: -15px;\n    }\n\n    .big-profile {\n      display: inline-block\n    }\n\n    p {\n      display: inline-block;\n      background: $color-neutral-dark;\n      color: $color-light-type;\n      padding: 7px;\n      margin: 0;\n      vertical-align: super;\n      font-family: $muso-700;\n    }\n  }\n\n  .test-last {\n    .title-sm {\n      font-size: 26px;\n    }\n\n    p {\n      font-size: 12px;\n      margin-bottom: 0px;\n      color: #666;\n    }\n  }\n\n  /* DAshboard-Map-Style-update*/\n  .product-box {\n    padding: 0;\n    border: none;\n    box-shadow: 10px 10px 10px -3px $body-content-color;\n\n    &:hover,\n    &:active {\n      border: none;\n      box-shadow: 3px 3px 7px 0px #a8a8a8;\n    }\n  }\n\n  .dashboard-wrapper .car-big-heading img {\n    max-width: 325px !important;\n  }\n\n  .practioner-dash-wrap {\n    margin-top: 0px;\n  }\n\n  .icon-btn {\n    position: absolute;\n    bottom: 5px;\n    font-size: 22px;\n    color: $body-content-color;\n    margin: auto;\n    left: 0;\n    right: 0;\n    display: inline-block;\n\n    &:hover {\n      color: #48ac51;\n    }\n  }\n\n  .fs-logo-feedback {\n    max-width: 350px;\n    margin: 30px auto 0;\n  }\n\n  #f-implement1 {\n    .profile-description {\n      font-size: 15px;\n\n      @media(max-width:960px) {\n        max-height: 245px;\n        overflow: hidden;\n        overflow-y: auto;\n      }\n\n      @media(max-width:767px) {\n        font-size: 12px;\n        max-height: 310px;\n\n        body.mini-navbar & {\n          max-height: 302px;\n        }\n      }\n\n      @media(max-width:414px) {\n        max-height: 250px;\n      }\n\n      @media only screen and (max-height: 414px) and (orientation:landscape) {\n        max-height: 115px !important;\n        font-size: 13px !important;\n      }\n    }\n\n    .fix-label {\n      font-size: 23px;\n\n      @media(max-width:767px) {\n        font-size: 16px;\n        float: left;\n      }\n    }\n\n    .about-u {\n      padding: 10px;\n\n      @media(max-width:767px) {\n        margin-bottom: 5px;\n\n        .right-label-text {\n          font-size: 16px;\n          margin-bottom: 0px;\n          display: inline-block;\n          vertical-align: top;\n          padding: 7px;\n          //background: $clarify-color !important;\n          float: right;\n        }\n      }\n    }\n\n    .right-label-text {\n      font-size: 18px;\n      color: $color-light-type;\n\n      span {\n        padding: 8px;\n\n        @media (max-width:992px) {\n          padding: 3px;\n          font-size: 14px;\n        }\n      }\n    }\n  }\n\n  //div.wrap-all-boxes.tabled-display.new-dashboard > div.practioner-dash-wrap > div.pre-work.common-section-wrap.col-sm-3 > div > div:nth-child(3) > div > div > div.ibox-content.product-box > div.product-imitation.ng-binding > a, div.wrap-all-boxes.tabled-display.new-dashboard > div.practioner-dash-wrap > div.session.common-section-wrap.col-sm-3 > div > div:nth-child(5) > div > div > div.ibox-content.product-box > div.product-imitation.ng-binding > a, div.wrap-all-boxes.tabled-display.new-dashboard > div.practioner-dash-wrap > div.session.common-section-wrap.col-sm-3 > div > div:nth-child(6) > div > div > div.ibox-content.product-box > div.product-imitation.ng-binding > a{\n  //  color:#48ac51;\n  //}\n\n  /* feedback-large-icon*/\n\n  .big-profile {\n\n    .profile_types {\n      background: url('#{$assets}/images/foursight-profile-types-lg.png') !important;\n      width: 160px;\n      height: 80px;\n    }\n\n    .developer {\n      background-position: -680px -84px !important;\n    }\n\n    .accelerator {\n      background-position: -170px 0 !important;\n    }\n\n    .analyst {\n      background-position: 0 -174px !important;\n    }\n\n    .clarifier {\n      background-position: -345px -174px !important;\n    }\n\n    .driver {\n      background-position: -334px 0 !important;\n    }\n\n    .early-bird {\n      background-position: -338px -84px !important;\n    }\n\n    .finisher {\n      background-position: -676px 0 !important;\n    }\n\n    .hare {\n      background-position: -512px -174px !important;\n    }\n\n    .idea-broker {\n      background-position: -506px 0 !important;\n    }\n\n    .ideator {\n      background-position: 0 -84px !important;\n    }\n\n    .implementer {\n      background-position: -170px -84px !important;\n    }\n\n    .integrator {\n      background-position: -680px -196px !important;\n      margin-top: 0px;\n      height: 40px;\n    }\n\n    .optimist {\n      background-position: -172px -174px !important;\n    }\n\n    .realist {\n      background-position: -508px -84px !important;\n    }\n\n    .theorist {\n      background-position: 0 0 !important;\n    }\n  }\n\n  // Remove Download Option for Audio Files\n  video::-internal-media-controls-download-button,\n  audio::-internal-media-controls-download-button {\n    display: none;\n  }\n\n  video::-webkit-media-controls-enclosure,\n  audio::-webkit-media-controls-enclosure {\n    overflow: hidden;\n  }\n\n  video::-webkit-media-controls-panel,\n  audio::-webkit-media-controls-panel {\n    width: calc(100% + 30px);\n  }\n\n  .interactive-guide {\n    overflow: hidden;\n\n    .feedback {\n      box-shadow: 0px 0px 39px -5px $body-content-color;\n      margin: 0px !important;\n    }\n  }\n\n  ::ng-deep.flipbook {\n    width: 100% !important;\n    margin-top: 60px;\n\n    .page-wrapper {\n      margin: 0 auto !important;\n    }\n\n    &-viewport {\n      overflow: hidden;\n      width: 100%;\n      height: 100%;\n\n      .container {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        margin: auto;\n      }\n\n      .flipbook {\n        width: 922px;\n        height: 600px;\n        left: -461px;\n        top: -300px;\n      }\n\n      .page {\n        width: 461px;\n        height: 600px;\n        background-color: white;\n        background-repeat: no-repeat;\n        background-size: 100% 100%;\n      }\n\n      .shadow {\n        -webkit-transition: -webkit-box-shadow 0.5s;\n        -moz-transition: -moz-box-shadow 0.5s;\n        -o-transition: -webkit-box-shadow 0.5s;\n        -ms-transition: -ms-box-shadow 0.5s;\n        -o-box-shadow: 0 0 20px $color-neutral-mid;\n        -ms-box-shadow: 0 0 20px $color-neutral-mid;\n        box-shadow: 0 0 20px $color-neutral-mid;\n      }\n    }\n\n    .page {\n      -ms-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n      -o-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n      box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n\n      img {\n        -webkit-touch-callout: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n        margin: 0;\n        max-width: 100%;\n      }\n    }\n\n    .feedback-footer audio {\n      vertical-align: bottom;\n      margin-top: 12px;\n      margin-bottom: 0px;\n    }\n\n    .f-score .col-xs-7 img {\n      width: 100%;\n    }\n\n    #f-implement img {\n      max-width: 100%;\n    }\n\n    .feedback-footer audio {\n      width: calc(100% - 165px);\n      min-width: 0px;\n    }\n\n    #f-zone .feedback-content p {\n      margin-top: 25%;\n    }\n\n    #congo .title-sm {\n      margin-top: 15%;\n    }\n\n    #f-implement .title-sm {\n      margin-bottom: 12%;\n    }\n\n    .feedback .custom-col {\n      width: 23%;\n      margin: 1%;\n    }\n  }\n\n  .flip-control {\n    text-align: center;\n\n    a {\n      display: inline-block;\n      margin: 0px 5px;\n    }\n  }\n\n  @media only screen and (min-width:1000px) and (max-width:1200px) {\n\n    .flipbook {\n\n      .col-xs-7,\n      .col-xs-5 {\n        width: 100%;\n      }\n\n      .title-sm {\n        font-size: 26px !important;\n      }\n\n      .feedback .title {\n        font-size: 40px;\n        line-height: 42px;\n      }\n    }\n  }\n\n  @media only screen and (max-width:767px) {\n\n    .flipbook {\n\n      .title-sm {\n        font-size: 26px !important;\n      }\n\n      .feedback .title {\n        font-size: 40px;\n        line-height: 42px;\n      }\n    }\n  }\n\n  @media only screen and (max-width:420px) {\n\n    .flipbook {\n\n      .col-xs-7,\n      .col-xs-5 {\n        width: 100%;\n      }\n\n      .feedback .custom-col {\n        width: 48%;\n        margin: 1%;\n      }\n\n      #think {\n        background-size: inherit !important;\n        background-position-y: 50% !important;\n      }\n\n      #f-profile {\n\n        .title-sm {\n          margin-bottom: 28%;\n        }\n      }\n    }\n  }\n\n  .circled-preference {\n    border: 2px solid;\n    border-radius: 65% 65%;\n    padding: 20px 0px;\n  }\n}\n\n\n\n/* full-screen-style */\n\n#full-screen {\n  margin-left: 15px;\n  margin-right: 15px;\n}\n\na#exit-screen {\n  display: none;\n  position: absolute;\n  top: 20px;\n  right: 30px;\n  font-size: 18px;\n  color: #6c6c6c;\n}\n\n::ng-deep body.full-screen {\n\n  @media only screen and (max-width: 767px) and (orientation:portrait) {\n    overflow: hidden;\n    position: fixed;\n  }\n\n  .feedback-page {\n    position: fixed;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 999999;\n    background: $color-light-type;\n    left: 0;\n    margin-top: 0px;\n    padding: 0px;\n\n    @media only screen and (max-height:414px) and (orientation:landscape) {\n      position: absolute;\n      overflow: hidden;\n      //-webkit-overflow-scrolling: touch;\n    }\n  }\n\n  .feedback-slider {\n    margin: 0px;\n  }\n\n  a#exit-screen {\n    display: block;\n    z-index: 99;\n  }\n\n  .feedback {\n    max-width: 100%;\n    top: 0;\n    bottom: 0;\n\n    // p {\n    //   font-size:36px;\n    // }\n\n    // ul li {\n    //   font-size: 36px;\n    // }\n  }\n\n  // #nav {\n  //   max-width: 100% !important;\n  //   bottom:0;\n  // }\n\n  // #Dots {\n  //   bottom: 0;\n  //   max-width: 100%;\n  //   padding-left: 34%;\n  // }\n\n  // #feed-banner .title {\n  //   font-size: 2em;\n  // }\n\n  // #great-mind .title-sm , .feedback .title-sm{\n  //   font-size: 1.5em;\n  // }\n\n  .custom-row {\n    overflow: hidden;\n    width: 100%;\n  }\n\n  // .feedback .custom-col {\n  //   float:left;\n  //   margin: 1%;\n  //   width:23%;\n\n  //   img {\n  //     max-width: 80%;\n  //     width:100%;\n  //   }\n\n  //   p {\n  //     font-size:30px;\n  //   }\n  // }\n\n  // #f-bulb {\n  //   background-size: 432px 467px !important;\n\n  //   .title {\n  //     font-size: 2em;\n  //     line-height: 80px;\n  //   }\n  // }\n\n  // #congo {\n\n  //   .feedback-content {\n  //     margin-top: 15%;\n  //   }\n  // }\n\n  // #f-profile {\n\n  //   .feedback-content {\n\n  //     p {\n  //       margin-top: 5%;\n\n  //       img {\n  //         max-width: 50%;\n  //         width: 100%;\n  //       }\n  //     }\n  //   }\n  // }\n\n  // .feedback-content {\n\n  //   .f-sight, .f-score {\n\n  //     img {\n  //       max-width: 80%;\n  //       width:100%;\n  //     }\n  //   }\n  // }\n\n  .owl-carousel {\n    .feedback-content {\n\n      .f-sight,\n      .f-score {\n\n        img {\n          max-width: 150px;\n          width: 100%;\n\n          @media only screen and (max-height: 414px) and (orientation:landscape) {\n            max-width: 115px;\n          }\n\n        }\n      }\n    }\n  }\n\n  // #f-now {\n  //   .title-sm {\n  //     font-size: 2em;\n  //   }\n  // }\n}\n\n\n::ng-deep body.full-screen #owl-demo {\n  width: 90%;\n  margin-top: 35px;\n}\n\n@media only screen and (min-width:768px) {\n  ::ng-deep body.full-screen #owl-demo {\n    margin-top: 60px;\n  }\n}\n\n@media only screen and (max-height:736px) and (orientation:portrait) {\n  ::ng-deep body.full-screen #owl-demo {\n    /*width: 90%;*/\n    margin-top: 40px;\n  }\n}\n\n@media only screen and (max-height:414px) and (orientation:landscape) {\n  ::ng-deep body.full-screen #owl-demo {\n    margin-top: 40px;\n    /*width: 100%;\n      margin-top: 0px;\n      -webkit-transform: scale(0.61);\n      -moz-transform: scale(0.61);\n      -ms-transform: scale(0.61);\n      -o-transform: scale(0.61);\n      transform: scale(0.61);\n      position: relative;\n      top: -70px;\n      margin-left: -75px;\n      width:90%;*/\n  }\n}\n\n@media only screen and (max-width:767px) {\n  ::ng-deep body.full-screen {\n    .feedback ul li {\n      font-size: 20px;\n    }\n\n    .feedback .custom-col p {\n      font-size: 16px;\n    }\n\n    a#exit-screen {\n      font-size: 16px;\n    }\n\n    .feedback p {\n      font-size: 16px;\n    }\n\n    .owl-carousel {\n      .feedback {\n        ul li {\n          font-size: 16px;\n        }\n\n        p {\n          font-size: 16px;\n        }\n\n        .custom-col {\n          float: none;\n        }\n      }\n\n      #f-bulb {\n        background-size: contain !important;\n      }\n    }\n  }\n}\n\n::ng-deep .work-well-slide {\n  h3 {\n    font-size: 22px;\n  }\n\n  .title-sm {\n    margin-bottom: 50px !important;\n\n    @media(max-width: 767px) {\n      margin-bottom: 25px !important;\n    }\n\n  }\n\n  .disabled {\n    height: 50px;\n    vertical-align: middle;\n    margin-top: 35px;\n    font-size: 28px;\n\n    @media(max-width: 767px) {\n      margin: 0px;\n    }\n  }\n}\n\n\n@media (min-width: 680px) {\n  .new-dashboard .col-sm-3 {\n    max-width: 180px;\n  }\n}\n\n@media only screen and (max-width:767px) {\n  ::ng-deep .feedback-page {\n\n    .col-xs-7,\n    .col-xs-5 {\n      width: 100%;\n    }\n\n    .feedback-content {\n      padding: 20px 20px 0;\n    }\n\n    #prevtBtn,\n    #nextBtn {\n      font-size: 25px !important;\n      bottom: 8px;\n    }\n\n    #prevtBtn {\n      margin-right: 30px !important\n    }\n\n    #nextBtn {\n      right: 4px;\n    }\n\n    // .feedback-footer audio {\n    //   width: 100%;\n    // }\n\n    div#Dots {\n      padding-left: 16%;\n\n      .Dot {\n        width: 5px;\n        height: 5px;\n        margin: 3px;\n      }\n    }\n\n    a#exit-screen {\n      top: 5px;\n      right: 5px;\n    }\n  }\n}\n\n\n\n@media only screen and (max-height: 414px) and (orientation:landscape) {\n  ::ng-deep .feedback-page {\n    .col-xs-7 {\n      width: 50% !important;\n    }\n\n    .col-xs-5 {\n      width: 50% !important;\n    }\n  }\n\n  ::ng-deep .work-well-slide .center-block {\n    text-align: center;\n  }\n\n  ::ng-deep .work-well-slide .col-sm-2,\n  .work-well-slide .col-sm-5 {\n    display: inline-block;\n    vertical-align: middle;\n    width: 25%;\n  }\n\n  ::ng-deep body.full-screen {\n    width: 100%;\n    overflow: hidden;\n\n    #owl-demo .item {\n      min-height: 260px !important;\n    }\n\n    #owl-demo #think.item {\n      background-size: 60% auto !important;\n      background-position: center center !important;\n    }\n\n    #page-wrapper {\n      min-height: 414px;\n    }\n\n    .feedback p {\n      font-size: 12px !important;\n    }\n\n    .owl-carousel {\n      .title {\n        font-size: 25px !important;\n        line-height: 1.1 !important;\n      }\n\n      .feedback {\n        .title-sm {\n          font-size: 15px !important;\n          margin-bottom: 5px;\n        }\n\n        .f-sight {\n          margin-top: 15px;\n        }\n\n        ul li {\n          font-size: 14px !important;\n        }\n\n        p {\n          font-size: 14px !important;\n        }\n\n        .custom-col {\n          width: 15%;\n        }\n\n        .feedback-footer {\n          max-height: 40px;\n          padding: 0px 5px;\n\n          .author-logo {\n            max-width: 40px;\n          }\n\n          .feedback-player {\n            padding: 0px 5px;\n            max-height: 40px;\n\n            audio {\n              height: 40px;\n              margin-bottom: 0px;\n            }\n          }\n        }\n      }\n\n      #f-profile #chartarea {\n        -webkit-transform: scale(0.58);\n        -moz-transform: scale(0.58);\n        -ms-transform: scale(0.58);\n        -o-transform: scale(0.58);\n        transform: scale(0.58);\n        margin-top: -40px;\n        width: 100%;\n      }\n\n      #clar-result #chartarea,\n      #w-ideat-result #chartarea,\n      #w-develop-result #chartarea,\n      #w-impl-result #chartarea {\n        -webkit-transform: scale(0.9);\n        -moz-transform: scale(0.9);\n        -ms-transform: scale(0.9);\n        -o-transform: scale(0.9);\n        transform: scale(0.9);\n      }\n\n      #f-implement {\n        img {\n          max-width: 200px;\n        }\n      }\n    }\n  }\n}\n\n::ng-deep .feedback-page {\n  img {\n    max-width: 100%;\n  }\n\n\n\n  .feedback .custom-col {\n    width: 23%;\n    margin: 1%;\n\n    @media(max-width:767px) {\n      width: 20%;\n      max-width: 122px !important;\n      display: inline-block;\n      float: none;\n    }\n\n    @media(max-width:599px) {\n      width: 33%;\n      max-width: 105px !important;\n\n      ::ng-deep body.mini-navbar & {\n        width: 39%;\n      }\n    }\n  }\n\n  .feedback {\n    @media(max-width:767px) {\n      .custom-row {\n        margin: 0 auto;\n        display: inline-block;\n        text-align: center;\n        width: 100%;\n      }\n\n      .custom-col {\n        &:nth-child(3) {\n          clear: both;\n        }\n      }\n    }\n  }\n\n  .c-profile img {\n    max-width: 300px;\n  }\n}\n\n\n::ng-deep .feedback {\n  max-width: 980px;\n  margin: auto;\n  right: 0;\n  text-align: left !important;\n  font-family: $muso-300;\n  background: $color-light-type;\n\n  .title {\n    font-size: 60px;\n    margin: 0px;\n    font-weight: 600;\n    font-family: $muso-700;\n  }\n\n  .title-sm {\n    font-size: 40px;\n\n    @media(max-width:991px) {\n      font-size: 30px;\n    }\n\n    @media(max-width:800px) {\n      font-size: 27px;\n    }\n\n    margin: 0px 0 10px;\n    font-weight:600;\n    font-family: $muso-300;\n  }\n\n  .custom-row {\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: -15px;\n\n    .custom-col {\n      width: 25%;\n      padding-inline: 15px;\n\n      @media #{$mobile} {\n        width: 50%;\n      }\n    }\n  }\n\n  p {\n    font-size: 18px;\n  }\n\n  ul {\n    padding: 0 0 0 22px;\n    margin: 0px;\n\n    li {\n      font-size: 18px;\n      line-height: 26px;\n\n      @media(max-width:767px) {\n        font-size: 15px;\n\n        body.mini-navbar & {\n          font-size: 14px;\n        }\n      }\n\n    }\n  }\n}\n\n@media only screen and (max-width:767px) {\n\n  ::ng-deep .feedback-page {\n\n    .title-sm {\n      font-size: 20px !important;\n      margin-bottom: 25px;\n    }\n\n    .feedback .title {\n      font-size: 40px;\n      line-height: 42px !important;\n    }\n  }\n\n  body.full-screen {\n\n    .owl-carousel {\n      .feedback .title-sm {\n        font-size: 20px !important;\n      }\n\n      .title {\n        font-size: 40px;\n        line-height: 42px !important;\n      }\n    }\n  }\n}\n\n@media only screen and (max-height: 736px) and (orientation:portrait) {\n  body.full-screen {\n    #owl-demo {\n      .item {\n        min-height: 430px;\n      }\n    }\n\n    .owl-carousel {\n      .feedback {\n        .title-sm {\n          margin-bottom: 10px !important;\n          font-size: 18px !important;\n        }\n\n        .custom-col {\n          max-width: 98px !important;\n        }\n\n        .title {\n          font-size: 35px !important;\n          line-height: 1.1 !important;\n        }\n\n        ul li {\n          font-size: 14px !important;\n        }\n\n        p {\n          font-size: 14px !important;\n          margin-bottom: 0px;\n        }\n\n        .fs-logo-feedback {\n          img {\n            max-width: 250px;\n          }\n        }\n\n        .center-block {\n          -webkit-transform: scale(0.8);\n          -moz-transform: scale(0.8);\n          -ms-transform: scale(0.8);\n          -o-transform: scale(0.8);\n          transform: scale(0.8);\n          margin-top: -15px;\n        }\n      }\n\n      #f-implement1 .profile-description {\n        max-height: 255px;\n      }\n    }\n\n  }\n}\n\n@media print {\n\n  @page {\n    size: letter landscape;\n  }\n\n  body {\n    width: 100%;\n    height: 100%;\n    -webkit-transform: rotate(-90deg);\n    -moz-transform: rotate(-90deg);\n    max-height: 100%;\n    max-width: 100%\n  }\n\n  ::ng-deep body {\n    width: 100% !important;\n  }\n\n  ::ng-deephtml {\n    width: 100% !important;\n  }\n\n  ::ng-deepbody.fs-skin #wrapper {\n    overflow: visible !important;\n  }\n\n  ::ng-deep .cig-parent-wrapper {\n    #owl-demo {\n      max-width: 100% !important;\n    }\n\n    .owl-carousel .owl-wrapper-outer {\n      overflow: visible !important;\n    }\n\n    .owl-item {\n      float: none !important;\n      width: 100% !important;\n      min-height: 100% !important;\n      // transform: rotate(90deg) !important;\n      clear: both;\n      page-break-before: always !important;\n      //page-break-after: always !important;\n      display: block !important;\n      transform: translateY(20%) !important;\n    }\n\n    .owl-carousel .owl-wrapper {\n      page-break-inside: always !important;\n      float: none !important;\n    }\n\n    .owl-carousel .owl-wrapper,\n    .owl-carousel .owl-item {\n      width: 100% !important;\n      white-space: normal !important;\n      visibility: visible !important;\n      opacity: 1 !important;\n      float: none !important;\n    }\n\n    #feed-banner {\n      background-image: url('https://assets.foursightonline.com/app/images/feed-banner.png') !important;\n    }\n\n    #great-mind {\n      background-image: url('https://assets.foursightonline.com/app/images/2nd-page.png') !important;\n    }\n\n    #think {\n      background-image: url('https://assets.foursightonline.com/app/images/think-pref.png') !important;\n    }\n\n    #f-bulb {\n      background-image: url('https://assets.foursightonline.com/app/images/feed-bulb.png') !important;\n    }\n\n    #f-now {\n      background-image: url('https://assets.foursightonline.com/app/images/f-now.png') !important;\n    }\n\n    #f-end {\n      background-image: url('https://assets.foursightonline.com/app/images/f-end.png') !important;\n    }\n\n    .feedback-footer {\n      display: none !important;\n    }\n\n    .owl-controls {\n      display: none !important;\n    }\n  }\n\n  ::ng-deep body.fs-skin #hubspot-messages-iframe-container.widget-align-right {\n    display: none !important;\n  }\n}\n\n\n::ng-deep.translate-btn {\n  position: absolute;\n  bottom: 18px;\n  right: 11%;\n}\n\n::ng-deep.translate-text {\n  font-size: 16px !important;\n  max-width: 980px;\n  margin: 20px auto 0 auto;\n\n  .well {\n    max-height: 180px;\n    overflow-y: auto;\n  }\n}\n\n\n\n::ng-deep.feedback-player {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n::ng-deep.cig-parent-wrapper {\n  .owl-buttons {\n    position: absolute;\n    right: 15px;\n    top: auto;\n    bottom: 35px;\n\n    @media only screen and (max-width: 991px) {\n      bottom: -13px;\n    }\n\n    @media only screen and (max-width: 767px) {\n      bottom: 3px;\n    }\n\n    @media only screen and (max-width: 575px) {\n      position: static;\n    }\n  }\n}\n\n::ng-deep.translate-btn {\n  position: absolute;\n  bottom: 55px;\n  right: 110px;\n  background: transparent !important;\n  border: transparent !important;\n  color: #6c6c6c !important;\n\n  &:active {\n    box-shadow: none !important;\n  }\n\n  i::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: block;\n  }\n\n  @media only screen and (max-width: 991px) {\n    bottom: 29px;\n  }\n\n  @media only screen and (max-width: 575px) {\n    right: 10px;\n  }\n\n\n}\n\n::ng-deep.translate-btn.translate-btn2 {\n  right: 158px;\n}\n\n::ng-deep.feedback-footer {\n  audio+img+img {\n\n    @media only screen and (max-width: 991px) {\n      display: none;\n    }\n  }\n}\n\n\n::ng-deep.item {\n\n  &.feedback {\n    // min-height: 515px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n    // background-image: linear-gradient(357deg, rgba(233,233,233,1) 0%, rgba(233,233,233,1) 47%, rgba(255,255,255,1) 100%);\n    background-color: transparent;\n\n    &--notitle {\n      // min-height: 453px;\n      background-size: 100% 100%;\n    }\n\n    &--fullscr {\n      height: 90% !important;\n    }\n\n    &--mh {\n      min-height: auto;\n    }\n\n    &--thanku {\n\n      .test-last {\n\n\n        h2 {\n          font-size: 26px;\n          margin-bottom: 26px;\n        }\n\n        button {\n          margin-bottom: 10px;\n        }\n\n        p {\n          font-size: 12px;\n          margin-bottom: 0px;\n          color: #666;\n        }\n\n        .fs-icon {\n\n          a {\n            margin: 5px;\n            cursor: pointer;\n          }\n        }\n\n      }\n    }\n\n    &--colpro {\n\n      .cig_collab_img {\n\n        img {\n          max-width: 100%;\n          max-height: 300px;\n        }\n      }\n    }\n\n    &--wn {\n\n      h2 {\n        float: left;\n        background: rgba(243, 243, 243, 0.3) !important;\n        min-width: 200px;\n        padding: 10px;\n      }\n    }\n\n    &--wsyk {\n\n      .feedback-content {\n\n        .fs-logo-feedback {\n          max-width: 350px;\n          margin: 30px auto 0;\n\n          img {\n            max-width: 100%;\n          }\n\n        }\n\n      }\n\n    }\n\n    &--au {\n\n      .feedback-content {\n\n        .profile-description {\n          font-size: 17px;\n        }\n\n        .about-u {\n          background: #F1F1F2;\n          overflow: hidden;\n          margin-bottom: 10px;\n          padding: 10px;\n\n          .fix-label {\n            background: #6D6E71;\n            color: #fff;\n            padding: 7px;\n            font-family: \"Museo-700\";\n            display: inline-block;\n            vertical-align: top;\n          }\n\n          .right-label {\n            display: block;\n            margin-bottom: 10px;\n            text-align: right;\n\n            span {\n              padding: 8px;\n              color: #fff;\n            }\n\n            .eq-developer {\n              font-size: 16px;\n            }\n          }\n        }\n      }\n    }\n\n    &--wc {\n      color: #fff;\n    }\n\n    &--bg {\n      background-size: cover;\n    }\n\n    &--bulbbg {\n      background-color: #bfbfbf !important;\n      background-size: cover;\n\n      h1 {\n        position: absolute;\n        top: 50%;\n        text-align: center;\n        left: 0;\n        right: 0;\n        transform: translateY(-50%);\n        line-height: 60px;\n      }\n    }\n\n    &--mb {\n\n      .title-sm {\n        margin-bottom: 30px;\n      }\n    }\n\n    &--mt {\n\n      .high_prefer {\n        top: 4px;\n      }\n\n      .col-xs-5 {\n        margin-top: 28px;\n      }\n\n    }\n\n    .feedback-test_result {\n      max-width: 400px;\n      margin: 0px auto;\n      text-align: center;\n\n      @media only screen and (max-height: 414px) and (orientation:landscape) {\n        -webkit-transform: scale(0.8);\n        -moz-transform: scale(0.8);\n        -ms-transform: scale(0.8);\n        -o-transform: scale(0.8);\n        transform: scale(0.8);\n        margin-top: -15px;\n      }\n\n      .big-profile {\n        display: inline-block;\n        transform: scale(3);\n        transform-origin: right;\n        margin: 20px 15px;\n      }\n\n      // .profile_types {\n      //   width: 160px;\n      //   height: 80px;\n      //   background-position: -680px -84px !important;\n      //   background-image: url(https://assets.foursightonline.com/app/images/foursight-profile-types-lg.png) !important;\n      // }\n\n      p {\n        display: inline-block;\n        background: #6D6E71;\n        color: #fff;\n        padding: 7px;\n        margin: 0px 0 0 0;\n        vertical-align: super;\n        font-family: \"Museo-700\";\n        position: relative;\n        top: -9px;\n      }\n\n    }\n\n  }\n\n  .feedback-content {\n    padding: 50px 50px;\n\n    @media #{$tablet} {\n      padding: 20px;\n    }\n\n    .f-sight {\n      margin-top: 45px;\n\n      @media #{$mobile} {\n\n        .col-xs-7 {\n          width: 100%;\n          margin-top: 10px;\n        }\n      }\n    }\n\n    img {\n      max-width: 500px;\n      width: 100%;\n    }\n\n    h1 {\n\n      &.title {\n        font-size: 38px;\n        max-width: 30%;\n        width: 100%;\n        font-family: $muso-300;\n\n        @media #{$tablet} {\n          font-size: 30px;\n        }\n\n        @media #{$mobile} {\n          font-size: 22px;\n        }\n      }\n\n    }\n\n\n  }\n\n}\n\n\n@mixin alignCenter {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n@mixin allCenter() {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n}\n\n::ng-deep {\n\n  body {\n    --lmslider_size: 40px;\n\n    &.mini-navbar {\n      \n      &:not(.full-scr) {\n\n        @media #{$mobile} {\n          --lmslider_size: 30px;\n        }\n      }\n      \n    }\n  }\n\n}\n\n::ng-deep .lmslider {\n  --clrLight: #eee;\n  --clrDarkGrey: #6D6E71;\n  --secPad: 30px;\n\n  width: min(976px, 100%);\n  margin: 0 auto !important;\n  padding: 40px !important;\n\n  @media #{$tablet} {\n    padding: 20px !important;\n  }\n\n  @media #{$mobile} {\n    --secPad: 20px;\n  }\n\n  .lmslider {\n    padding: 0 !important;\n  }\n\n\n\n  &__top {\n    background-color: #eee;\n    padding: var(--secPad);\n    padding-bottom: calc(var(--secPad) + 10px);\n\n    @media #{$tablet} {\n      padding: 20px 20px 40px;\n    }\n\n    @media #{$mobile} {\n      padding: 0 0 40px;\n    }\n\n  }\n\n  &__blocks {\n    background-color: transparent;\n    position: relative;\n\n    ::ng-deep .video-mp4 {\n\n      video {\n        height: 460px !important;\n        cursor: pointer;\n      }\n    }\n\n    ::ng-deep .youtube {\n\n      iframe {\n        height: 512px;\n        width: 100%;\n      }\n    }\n\n  }\n\n  &__img-wrapper {\n    position: relative;\n    padding-bottom: 56.25%;\n\n    .lmslider--swc & {\n      padding-bottom: 0;\n      min-height: 512px;\n    }\n\n    @media #{$mobile} {\n\n      .lmslider--swc & {\n        min-height: 240px;\n      }\n    }\n\n  }\n\n  &__bg-img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: bottom;\n\n  }\n\n  .feedback-wrapper {\n    position: relative;\n  }\n\n  &__slnum {\n\n    input {\n      width: 30px;\n      height: 22px;\n      padding: 0;\n      text-align: center;\n      border: 1px solid #ada4a4;\n      font-family: 'Open Sans';\n      color: inherit;\n      border-radius: 0;\n\n      &[type=number] {\n\n        &::-webkit-outer-spin-button,\n        &::-webkit-inner-spin-button {\n          -webkit-appearance: none;\n          margin: 0;\n        }\n      }\n    }\n\n  }\n\n  &__dots {\n    position: absolute;\n    bottom: -40px;\n    left: 0;\n    width: 100%;\n    height: 45px;\n    padding-top: 15px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n\n    &--dot {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      list-style: none;\n      padding-right: 11px;\n      margin-bottom: 0;\n      margin-top: 0;\n\n      li {\n        min-height: 5px;\n        max-width: 5px;\n        border-radius: 50%;\n        background-color: #fff;\n        width: 100%;\n        margin-left: 3px;\n        cursor: pointer;\n        min-width: 5px;\n\n        &.active {\n          background-color: #6D6E71;\n        }\n      }\n\n      @media #{$mobile} {\n        padding-inline: 0;\n      }\n    }\n  }\n\n  &__ftr {\n    width: 100%;\n    background-color: #fff;\n    padding: 10px;\n\n    @media #{$mobile} {\n      padding-inline: 0;\n    }\n\n    &--pos {\n      position: relative;\n    }\n\n    &row {\n      --flexGap: 10px;\n      --flexGap-minus: calc(-1 * var(--flexGap));\n      @include alignCenter();\n      justify-content: flex-end;\n      margin: 0 var(--flexGap-minus);\n      grid-row-gap: 8px;\n\n      @media #{$mobile} {\n        justify-content: center;\n        --flexGap: 5px;\n      }\n\n      &>div {\n        padding-right: var(--flexGap);\n        padding-left: var(--flexGap);\n      }\n\n      .flex-1 {\n        flex: 1;\n\n        &--minw200 {\n          min-width: 200px;\n        }\n      }\n    }\n\n    &auth {\n\n      img {\n        width: var(--lmslider_size);\n        height: var(--lmslider_size);\n        border-radius: 50%;\n      }\n    }\n\n    &player {\n      line-height: 0;\n\n      audio {\n        width: 100%;\n        height: var(--lmslider_size);\n      }\n    }\n\n    &_audio_player {\n      line-height: 0;\n\n      &_wrapper {\n\n        @media #{$mobile} {\n          flex: none !important;\n          width: 100%;\n          order: 1;\n        }\n      }\n\n      audio {\n        width: 100%;\n        height: var(--lmslider_size);\n      }\n    }\n\n    &vol {\n      width: var(--lmslider_size);\n      height: var(--lmslider_size);\n      background-color: var(--clrLight);\n      border-radius: 50%;\n      border: 0;\n      cursor: pointer;\n      @include allCenter();\n\n      &:hover {\n        background-color: var(--clrDarkGrey);\n        color: #fff;\n      }\n    }\n\n    &textbtn {\n\n      &--show {\n        display: block;\n      }\n    }\n\n    &textneg,\n    &texthide {\n      background-color: transparent;\n      border: 0;\n      font-size: 12px;\n      @include alignCenter();\n      padding: 4px;\n      transform: 0.3s;\n      font-family: 'Open sans';\n      color: #676a63;\n      cursor: pointer;\n\n      @media #{$mobile} {\n        padding: 1px;\n      }\n\n      i,\n      img {\n        margin-right: 8px;\n\n        @media #{$mobile} {\n          margin-right: 2px;\n        }\n      }\n    }\n\n    &texthide {\n\n      svg {\n        width: 16px;\n        margin-right: auto;\n        margin-left: 8px;\n      }\n    }\n\n    &arrows {\n      display: flex;\n      flex-wrap: wrap;\n      grid-gap: 10px;\n\n      @media #{$mobile} {\n        grid-gap: 6px;\n      }\n\n      &_wrapper {\n\n        @media #{$mobile} {\n          margin-left: auto;\n        }\n      }\n\n      a {\n        width: var(--lmslider_size);\n        height: var(--lmslider_size);\n        font-size: 18px;\n        background-color: transparent;\n        border-radius: 50%;\n        color: var(--clrDarkGrey);\n        border: 1px solid var(--clrDarkGrey);\n        @include allCenter();\n\n        @media #{$mobile} {\n          width: calc(var(--lmslider_size) - 6px);\n          height: calc(var(--lmslider_size) - 6px);\n          font-size: 12px;\n        }\n\n        &:hover {\n          background-color: var(--clrDarkGrey);\n          color: #fff;\n        }\n\n        svg {\n          width: 46%;\n          fill: #fff;\n\n          @media #{$mobile} {\n            width: 38%;\n          }\n        }\n      }\n\n      &--anbtn {\n\n        a {\n          background-color: var(--clrDarkGrey);\n          color: #fff;\n          opacity: 0.7;\n        }\n\n      }\n    }\n\n    .hideftr-item {\n      display: none;\n    }\n\n  }\n\n  &__notes {\n    background-color: var(--clrLight);\n    padding: var(--secPad);\n    margin-top: var(--secPad);\n\n    margin-top: 0px;\n  }\n}\n\n::ng-deep #page-wrapper {\n  min-height: 100vh;\n  padding-bottom: 70px;\n}\n\n.modal-body {\n\n  &.p-event {\n    pointer-events: all;\n  }\n}\n\n::ng-deep .full-scr {\n\n  .ibox {\n\n    &.product-detail {\n      margin: 0;\n    }\n  }\n\n  #learner-map {\n    display: none;\n  }\n\n\n  .wrapper.wrapper-content {\n    padding: 0;\n  }\n\n  .ibox-content--bdr {\n    padding: 0;\n  }\n\n  div#page-wrapper {\n    margin-left: 0px;\n    z-index: 99999;\n    padding: 0;\n  }\n\n  .page-heading {\n    display: none;\n  }\n\n  .new-dashboard {\n    display: none !important;\n  }\n\n  .navbar-default {\n    display: none;\n  }\n\n  .lmslider {\n    margin: 0;\n    width: 100%;\n    min-height: 100vh;\n    background-color: $clrGrey;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n    z-index: 999;\n\n    ::ng-deep .lmslider {\n      padding: 0;\n      min-height: auto;\n    }\n\n    &>* {\n      width: 100%;\n    }\n\n    &__ftr {\n      padding-inline: 10px;\n    }\n\n    .slidemap-text img {\n      max-height: 560px !important;\n    }\n\n    &__ftrarrows {\n\n      .full-screen-icon {\n        display: none !important;\n      }\n    }\n\n    &__ftrplayer {\n      line-height: 0;\n    }\n\n    &__ftrtextneg_wrapper {\n      display: none;\n    }\n\n\n    &__top {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding: 0;\n      width: min(1000px, 100%);\n\n      &:not(:last-child) {\n        margin-bottom: 20px;\n      }\n    }\n\n    &__notes {\n      margin-top: 0;\n      padding: 0;\n      width: 100%;\n\n      &_inner {\n        width: min(1000px, 100%);\n        margin-inline: auto;\n      }\n    }\n\n    &__blocks {\n      min-height: initial;\n      width: 100%;\n\n      &--full {\n        height: 100%;\n        min-height: initial;\n      }\n\n      &--fullw {\n        height: 90%;\n        min-height: initial;\n      }\n\n      .video-mp4 {\n\n        video {\n          object-fit: cover;\n          position: absolute;\n          height: 90% !important;\n        }\n      }\n\n      .lmslider {\n\n        &__dots {\n          display: none;\n        }\n\n        &__ftrtext {\n\n          &neg {\n            display: none;\n          }\n\n          &btn {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n\n  .item {\n\n    &.feedback {\n      min-height: initial;\n      height: 100%;\n      position: relative;\n      width: 100%;\n      max-width: 100%;\n      background-size: 100%;\n    }\n  }\n\n  footer,\n  .footer {\n    display: none;\n  }\n\n  .exit-full-scr {\n    display: flex !important;\n  }\n\n  .lm-an-cards {\n    display: none !important;\n  }\n\n  .exit-full-scr {\n    display: block;\n  }\n\n}\n\n.exit-full-scr {\n  display: none;\n}\n\n\n\n.loader-container {\n  position: absolute;\n  left: 0;\n  right: 0;\n  text-align: center;\n  top: 0;\n  bottom: 0;\n  background: rgba(236, 236, 236, .9);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: none;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  z-index: 9999999999;\n  height: 100vh;\n  margin: 0 auto;\n}\n\n.loader-spin {\n  background-color: hsla(0, 0%, 92.5%, .9);\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.loader__inner {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n\n}\n\n#Path_129 {\n  animation: blink 2s linear infinite;\n  opacity: 0;\n}\n\n#Path_130 {\n  animation: blink 2s linear infinite;\n  animation-delay: .5s;\n  opacity: 0;\n}\n\n#Path_132 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1s;\n  opacity: 0;\n}\n\n#Path_131 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1.5s;\n  opacity: 0;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n\n}\n\n.section-wrapper--lms {\n  padding: 0;\n}\n\n// Fallback slide for unknown types\n.feedback--fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  text-align: center;\n  padding: 40px;\n  background: #f8f8f9;\n\n  .feedback-fallback {\n    max-width: 600px;\n\n    h2 {\n      font-size: 28px;\n      font-weight: 700;\n      color: #4a4a4c;\n      margin: 0 0 16px;\n      font-family: $muso-500;\n    }\n\n    p {\n      font-size: 16px;\n      color: #676a6c;\n      line-height: 1.6;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
